var _polygon, _path, _polygon2, _path2, _polygon3, _path3, _polygon4, _path4, _path5, _polygon5, _path6, _path7, _path8, _path9, _polygon6, _polygon7, _polygon8, _polygon9, _path10, _path11, _polygon10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebDevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.83,89.87H161.76V43.8h46.07Zm-45.07-1h44.07V44.8H162.76Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.33,44.3c.11.1-9.9,10.27-22.35,22.72s-22.62,22.46-22.72,22.35,9.9-10.27,22.35-22.72S207.23,44.2,207.33,44.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,89.66a2.3,2.3,0,0,1-.41-.47l-1.07-1.41c-.92-1.23-2.27-3-4-5.17-3.37-4.34-8.2-10.22-13.88-16.39s-11.17-11.44-15.23-15.15c-2-1.85-3.68-3.34-4.84-4.35l-1.32-1.19c-.29-.27-.45-.42-.43-.44a3.22,3.22,0,0,1,.5.36l1.38,1.11c1.2,1,2.9,2.41,5,4.24,4.13,3.65,9.65,8.89,15.36,15.07S196.55,78,199.85,82.38c1.66,2.21,3,4,3.83,5.28l1,1.47A3.71,3.71,0,0,1,205,89.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.08,214.1H664V168h46.08Zm-45.08-1h44.08V169H665Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.58,168.53c.1.1-9.91,10.27-22.35,22.72S664.61,213.7,664.5,213.6s9.91-10.27,22.36-22.72S709.48,168.42,709.58,168.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.24,213.89a3.09,3.09,0,0,1-.4-.47L705.76,212c-.92-1.23-2.26-3-4-5.18-3.38-4.34-8.2-10.21-13.89-16.38S676.76,179,672.7,175.3c-2-1.86-3.69-3.34-4.84-4.36l-1.32-1.18a3.46,3.46,0,0,1-.44-.44,2.37,2.37,0,0,1,.51.36l1.38,1.11c1.2,1,2.89,2.41,5,4.24,4.13,3.64,9.66,8.89,15.37,15.07s10.48,12.11,13.79,16.51c1.65,2.2,3,4,3.83,5.28l1,1.47A2.22,2.22,0,0,1,707.24,213.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.75,284.83H34.67V238.75H80.75Zm-45.08-1H79.75V239.75H35.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.25,239.25c.1.11-9.91,10.28-22.36,22.73s-22.62,22.45-22.72,22.35,9.9-10.27,22.35-22.72S80.14,239.15,80.25,239.25Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.91,284.62a2.3,2.3,0,0,1-.41-.47l-1.07-1.41c-.92-1.24-2.27-3-4-5.18-3.37-4.34-8.2-10.21-13.88-16.38S47.42,249.74,43.36,246c-2-1.86-3.68-3.34-4.84-4.36l-1.32-1.18a2.88,2.88,0,0,1-.43-.44,2.52,2.52,0,0,1,.5.36l1.38,1.11c1.2,1,2.9,2.41,5,4.24,4.13,3.64,9.65,8.89,15.36,15.07s10.49,12.11,13.79,16.51c1.66,2.2,3,4,3.83,5.28l1,1.47A3.71,3.71,0,0,1,77.91,284.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.15,375.34a34.1,34.1,0,0,0-14.65-5c-2.4-.24-5-.17-6.93,1.28a1.41,1.41,0,0,0-.72,1.26,1.57,1.57,0,0,0,.68.87c6,4.55,15,5.12,21.62,1.64",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.77,374.92a71.4,71.4,0,0,1-9.46-8.33,23.93,23.93,0,0,1-5.93-11,4.41,4.41,0,0,1,.46-3.67c7.55,5.89,13.48,13.51,14.93,23",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.07,375.28a34.16,34.16,0,0,1,.18-12.43,16.74,16.74,0,0,1,6.62-10.25c1.3,3,.74,6.56-.18,9.74a47.32,47.32,0,0,1-6.56,13.82",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.47,388.53c-4.49.55-8.4,2.91-11.75,6A22.17,22.17,0,0,0,626,406c4.41-.28,8.14-3.38,10.85-6.86s4.59-7.31,7.57-10.56",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.07,390.65a29,29,0,0,1,3.35-27.42c2.56,9.1,1.62,19.38-3.35,27.42",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.84,402.28a21,21,0,0,0-20,11.54c-.25.5-.47,1.13-.14,1.57a1.49,1.49,0,0,0,1.33.39c4-.25,7.45-2.63,10.34-5.34s5.4-5.83,8.59-8.17",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.53,401.65a37.34,37.34,0,0,1-.37-20.85c.74-2.68,2-5.51,4.45-6.76a.84.84,0,0,1,.68-.12.91.91,0,0,1,.43.49,12.64,12.64,0,0,1,1,6,37.67,37.67,0,0,1-.94,6.05c-.78,3.7-1.2,7.68-3.22,10.87a22.1,22.1,0,0,0-1.3,2.39c-.38.81-.38,1.09-.73,1.74",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.4,405.51c-1.92-7.29.12-16.13,4.71-22.11.34-.44.79-.91,1.34-.86.84.08,1.06,1.21,1,2.06a40,40,0,0,1-7.08,20.91",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.73,407.1a32.16,32.16,0,0,0,26.38-5.37A21.37,21.37,0,0,0,695.83,400c-4.77,1.09-9.13,3.23-12.1,7.12",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M685.7,402.25c5-8.09,14.47-13.37,23.94-13.85-1.09,3.85-4.26,6.85-7.83,8.66s-7.56,2.6-11.49,3.36c-1.53.3-3.63.62-4.62,1.83",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.89,378.69a69.11,69.11,0,0,0,3.06-14c.37-4.78-.31-9.77-2.79-13.87-4.63,9-5.1,19.44-.41,28.38",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.49,370.81C702.91,361,714,353.1,725.15,352c-4.32,10.74-16.09,19-27.66,18.81",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.08,372.74c8.08,1.23,15,6.39,22.52,9.52a10.14,10.14,0,0,0,5.09,1,4,4,0,0,0,2.49-7.05,10.86,10.86,0,0,0-3.7-2.25c-8.22-3.42-17-3.51-25.7-1.43",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.41,378.41c1.82.52,2.45,1.47,3.9,2.7a42,42,0,0,0,17.07,8.77c.65.17,1.51.23,1.83-.36s-.07-1.14-.44-1.6a23.44,23.44,0,0,0-10.31-7c-3.94-1.47-7.35-3.24-12.05-2.86",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.13,344.18a32.33,32.33,0,0,0,24.77,8.43,1.72,1.72,0,0,0,1.13-.41c.62-.68-.13-1.72-.85-2.29-7.29-5.68-16.11-8-25-5.73",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.38,341.89a34.54,34.54,0,0,1,30.92-5.1,24.58,24.58,0,0,1-14.73,6.47,46.81,46.81,0,0,1-16.19-1.37",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.9,326.16c-.72-7.27-.25-13-.76-20.31,0-.59-.16-1.29-.71-1.5-.76-.29-1.39.64-1.64,1.42a23.27,23.27,0,0,0,3.1,20.23",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.38,327a42.71,42.71,0,0,0,12-11.7c2.38-3.25,4.38-7.15,3.84-11.15a11.54,11.54,0,0,0-8.69,4.32,24.16,24.16,0,0,0-4.42,8.9c-1,3.2-1.64,6.49-2.77,9.63",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.21,323.68a97.05,97.05,0,0,0,29.63-17.48c-3.54-1.42-7.59-.57-11.13.86a35.08,35.08,0,0,0-18.66,16.54",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.7,330.94c5.47.6,11,1,16.46.08s10.37-3,15.36-5.1a1.84,1.84,0,0,0,1-.8,1.19,1.19,0,0,0-.37-1.31,3.1,3.1,0,0,0-1.31-.61c-5.42-1.52-11.27-.81-16.6,1a77.11,77.11,0,0,0-14.58,6.75",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659.46,344.43c-3.73-7.54-3.49-16.33-.26-24.09,2.27,3.45,2.54,7.86,2.13,12s-1.67,8.36-1.75,12.49",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.55,336.91a33.61,33.61,0,0,0-25,10.63A23.39,23.39,0,0,0,633.26,345,70,70,0,0,0,645,337.17",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.53,333.55c-4.56-.37-8.95-.93-13.33.41A16,16,0,0,0,611,342.58a24.13,24.13,0,0,0,12.5-2.36,72.18,72.18,0,0,0,11-6.67",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.37,333.71c-4.1-2.69-8.31-5.43-13.09-6.54s-10.31-.29-13.64,3.31c3.87,2.27,8.56,2.54,13,2.53s10-.05,14.2,1.44",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.4,333.92c-7-6.88-9.67-19.25-6.85-28.66a43.67,43.67,0,0,1,6.85,28.66",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.67,314.42c1.33-3.08,2.26-6.3,3.44-9.43a27.11,27.11,0,0,1,4.91-8.7,12.94,12.94,0,0,1,8.68-4.5,35,35,0,0,1-16.85,22.68",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.19,318.48c-2.19-3-4.72-7.1-7.69-9.35s-6.83-3.61-10.45-2.74a24.35,24.35,0,0,0,18.14,12.09",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.88,314.67a52.39,52.39,0,0,1-3.46-11.2,17.48,17.48,0,0,1,1.76-11.39c3.85,7.27,5.09,15.08,1.9,22.67",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.71,292.08c2.18-7.22,8.78-12.53,15.91-15a5.86,5.86,0,0,1,2.79-.42,2.42,2.42,0,0,1,2.06,1.72c.26,1.22-.75,2.32-1.71,3.14a54.23,54.23,0,0,1-19,10.52",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.79,286.18c.28-4.65.57-9.37,2.08-13.78s4.43-8.54,8.67-10.46c.72,4.69-1.35,9.37-3.85,13.41s-5.51,7.85-7,12.36",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.67,289.38c-1.8-5.26-2-11.93-5.13-16.51-2.2-3.2-5.72-5.38-7.62-8.77a13.36,13.36,0,0,0,.44,9.95,28.85,28.85,0,0,0,5.83,8.34c2.33,2.49,4.32,4.36,6.48,7",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.71,444.17c-.14,0-.26-35.07-.27-78.31s.09-78.31.23-78.31.27,35.05.28,78.31S668.85,444.17,668.71,444.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.35,339.14a8.61,8.61,0,0,1-1.32.49l-3.62,1.23c-3.06,1-7.27,2.55-11.83,4.42s-8.77,3.51-11.2,5.61a8.2,8.2,0,0,0-2.25,3c-.35.83-.41,1.33-.46,1.32a1.23,1.23,0,0,1,0-.36,5.46,5.46,0,0,1,.26-1,7.9,7.9,0,0,1,2.19-3.17,19.86,19.86,0,0,1,4.86-3c2-.91,4.1-1.85,6.39-2.79,4.58-1.88,8.81-3.34,11.9-4.3,1.55-.48,2.81-.83,3.69-1.07A6.35,6.35,0,0,1,699.35,339.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M709.4,314.47a3.12,3.12,0,0,1-.37.39l-1.13,1.06-4.2,3.81-14,12.45c-5.46,4.86-10.17,9.5-13.44,13-1.64,1.74-2.93,3.19-3.81,4.2-.41.46-.74.85-1,1.16a2.58,2.58,0,0,1-.38.38s.09-.16.3-.45.52-.7.94-1.22c.84-1.05,2.09-2.54,3.69-4.32a178.67,178.67,0,0,1,13.37-13.13c5.48-4.84,10.46-9.2,14.08-12.34l4.31-3.69,1.19-1C709.23,314.56,709.38,314.45,709.4,314.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.83,337.12c-.14-.06,1-2.7,2.13-6s1.69-6.14,1.83-6.12a20.3,20.3,0,0,1-1.35,6.28,39.81,39.81,0,0,1-1.7,4.21A6.48,6.48,0,0,1,683.83,337.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.74,358.34a6.19,6.19,0,0,1-.84-1l-2.15-2.77c-1.81-2.33-4.31-5.56-7.12-9.1s-5.38-6.7-7.25-9l-2.2-2.73a6.63,6.63,0,0,1-.76-1,6,6,0,0,1,.91.91c.56.61,1.36,1.51,2.33,2.63,1.93,2.23,4.56,5.37,7.37,8.91s5.27,6.8,7,9.2c.87,1.2,1.56,2.18,2,2.86A5.67,5.67,0,0,1,668.74,358.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662,349.72a12.42,12.42,0,0,1-2.81-5.27,15.26,15.26,0,0,1-.64-5.31h.22c-.1.41-.17.62-.21.62s0-.23,0-.65l.23,0a24.14,24.14,0,0,0,.89,5.16A40.33,40.33,0,0,0,662,349.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.35,338.81a8.92,8.92,0,0,0-2-1.14,13.15,13.15,0,0,0-5.45-.44,34,34,0,0,0-5.5.89,16.81,16.81,0,0,1-2.26.54,8.1,8.1,0,0,1,2.17-.89,25.23,25.23,0,0,1,5.55-1,12,12,0,0,1,5.63.6A3.49,3.49,0,0,1,653.35,338.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.29,336.16c0,.08-1.14-.46-3-1.09a30.82,30.82,0,0,0-7.51-1.55,31.27,31.27,0,0,0-7.66.39c-1.94.35-3.11.71-3.14.63s.27-.16.8-.34a17.7,17.7,0,0,1,2.27-.64,26.89,26.89,0,0,1,15.37,1.17,19,19,0,0,1,2.15,1C651.05,336,651.31,336.13,651.29,336.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.67,325a64.41,64.41,0,0,1-2.19-7.63,63.07,63.07,0,0,1-1.71-7.75,61.77,61.77,0,0,1,2.2,7.63A60.54,60.54,0,0,1,668.67,325Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.81,325a36.36,36.36,0,0,0-2.43-4.56,20.32,20.32,0,0,0-3.58-3.7,3.3,3.3,0,0,1,1.38.71,11.41,11.41,0,0,1,2.62,2.69A10,10,0,0,1,668.81,325Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.71,425.48c-.05,0-.16-.85-.55-2.34a33.31,33.31,0,0,0-2.35-6.07c-2.42-4.95-6.83-11.22-12.43-17.51-2.77-3.17-5.47-6.16-7.75-9a64.09,64.09,0,0,1-5.55-8,39.81,39.81,0,0,1-2.8-5.94c-.25-.73-.44-1.3-.55-1.7a2.52,2.52,0,0,1-.14-.6s.3.8.88,2.23a44.58,44.58,0,0,0,2.92,5.83,67.63,67.63,0,0,0,5.6,7.88c2.3,2.83,5,5.81,7.77,9,5.62,6.3,10,12.66,12.38,17.69a30.86,30.86,0,0,1,2.21,6.18c.16.76.27,1.35.31,1.76A2.61,2.61,0,0,1,668.71,425.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.4,394.2A11.23,11.23,0,0,1,695,395a32,32,0,0,0-3.77,2.49,42.65,42.65,0,0,0-4.94,4.5c-1.73,1.84-3.52,4-5.35,6.25-3.64,4.57-7,8.62-9.1,11.85-1,1.61-1.79,3-2.28,3.91a13.49,13.49,0,0,1-.8,1.46s0-.15.13-.41.26-.66.49-1.14a35.94,35.94,0,0,1,2.16-4c2-3.31,5.37-7.41,9-12,1.83-2.29,3.64-4.42,5.4-6.25a39.32,39.32,0,0,1,5.07-4.47,26.7,26.7,0,0,1,3.89-2.38c.48-.24.87-.39,1.13-.5A1.48,1.48,0,0,1,696.4,394.2Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.94,404.35a22.41,22.41,0,0,1-3.07.44,40.3,40.3,0,0,0-7.27,1.44,21.66,21.66,0,0,0-6.51,3.41c-1.51,1.16-2.21,2.12-2.28,2.07s.12-.28.45-.71a11.76,11.76,0,0,1,1.6-1.63,19.8,19.8,0,0,1,6.58-3.63,32.79,32.79,0,0,1,7.4-1.3A16.35,16.35,0,0,1,696.94,404.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.7,410.59c-.16-.09,1.22-2.2,2.3-5s1.24-5.38,1.42-5.35a5.19,5.19,0,0,1,0,1.65,17.26,17.26,0,0,1-.9,3.87,18.31,18.31,0,0,1-1.78,3.56C679.15,410.14,678.76,410.63,678.7,410.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.37,367a2.58,2.58,0,0,1-.49.27l-1.45.65c-.63.27-1.39.61-2.26,1.07s-1.88.91-2.93,1.54l-1.67.95c-.58.33-1.16.73-1.77,1.11-1.23.75-2.47,1.67-3.78,2.61a65.09,65.09,0,0,0-14.59,15.1c-.9,1.35-1.78,2.62-2.48,3.88-.37.62-.74,1.21-1.06,1.8s-.6,1.16-.89,1.7c-.6,1.08-1,2.1-1.44,3s-.74,1.65-1,2.29l-.6,1.46a2,2,0,0,1-.25.5,2.36,2.36,0,0,1,.15-.53l.52-1.5c.22-.65.51-1.44.91-2.34s.8-1.94,1.38-3l.87-1.73c.31-.6.68-1.19,1-1.83.7-1.27,1.57-2.56,2.46-3.92a62.48,62.48,0,0,1,14.7-15.21c1.33-.94,2.59-1.85,3.84-2.59.62-.38,1.2-.77,1.79-1.1l1.7-.92c1.07-.62,2.1-1.06,3-1.49a24.89,24.89,0,0,1,2.31-1l1.48-.57A3.48,3.48,0,0,1,705.37,367Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.45,381.65a3.57,3.57,0,0,1,1.21-1.8,7.61,7.61,0,0,1,4.85-1.86,13.21,13.21,0,0,1,5.11,1,6.81,6.81,0,0,1,1.93.94,12.22,12.22,0,0,1-2-.6,15,15,0,0,0-5-.83,7.92,7.92,0,0,0-4.64,1.62A14.62,14.62,0,0,0,683.45,381.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.18,385a13,13,0,0,0,1.07-9.17,3.07,3.07,0,0,1,.57,1.3,9.3,9.3,0,0,1-.79,6.73C680.6,384.66,680.23,385.06,680.18,385Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.49,430.5c.76,13.4,4.8,27,11,40.81h27c5.92-13.64,9.68-27.25,10.35-40.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.48,452.18c0,.14-8.89.26-19.86.26s-19.86-.12-19.86-.26,8.89-.25,19.86-.25S688.48,452,688.48,452.18Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.88,457c0,.14-8.34.25-18.62.25s-18.62-.11-18.62-.25,8.33-.25,18.62-.25S687.88,456.9,687.88,457Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.93,439.3a74.53,74.53,0,0,1,0,12.44,77.5,77.5,0,0,1,0-12.44Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.4,439.3a79.89,79.89,0,0,1,0,12.88,83.07,83.07,0,0,1,0-12.88Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684,439.19a86.45,86.45,0,0,1,0,13.14,86.45,86.45,0,0,1,0-13.14Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692,439.3c0,.14-10.43.25-23.29.25s-23.3-.11-23.3-.25,10.43-.25,23.3-.25S692,439.16,692,439.3Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.14,116.54h-7.37v-1.47h7.37Zm-14.75,0H652v-1.47h7.37Zm-14.75,0h-7.37v-1.47h7.37Zm-14.75,0h-7.37v-1.47h7.37Zm45-1.62H673.4v-7.37h1.48Zm-57.38-.74H616v-7.37h1.48Zm57.38-14H673.4V92.79h1.48Zm-57.38-.74H616V92.06h1.48Zm57.38-14H673.4V78h1.48Zm-57.38-.74H616V77.31h1.48Zm57.38-14H673.4V63.29h1.48Zm-57.38-.74H616V62.56h1.48Zm54.13-10.77h-7.37V57.69h7.37Zm-14.75,0h-7.37V57.69h7.37Zm-14.75,0h-7.37V57.69h7.37Zm-14.75,0H620V57.69h7.37Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.26,64.58a5.43,5.43,0,1,1,5.42-5.42A5.43,5.43,0,0,1,617.26,64.58Zm0-9.37a3.95,3.95,0,1,0,4,3.95A4,4,0,0,0,617.26,55.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.85,64.58a5.43,5.43,0,1,1,5.42-5.42A5.43,5.43,0,0,1,673.85,64.58Zm0-9.37a3.95,3.95,0,1,0,3.95,3.95A4,4,0,0,0,673.85,55.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.26,122.78a5.43,5.43,0,1,1,5.42-5.43A5.44,5.44,0,0,1,617.26,122.78Zm0-9.38a3.95,3.95,0,1,0,4,3.95A4,4,0,0,0,617.26,113.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.85,122.78a5.43,5.43,0,1,1,5.42-5.43A5.44,5.44,0,0,1,673.85,122.78Zm0-9.38a3.95,3.95,0,1,0,3.95,3.95A4,4,0,0,0,673.85,113.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.26,76.64H633.64v-5h27.18v5H650.21v27h-6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.84,135.4H39.42l-1.83,4.25a9.41,9.41,0,0,0-.9,3.51,2.91,2.91,0,0,0,1.48,2.7,12.48,12.48,0,0,0,4.28.77v1.19H27.93v-1.19a6.42,6.42,0,0,0,3.86-1.94,25.94,25.94,0,0,0,3.74-6.59l15.61-34.83h.61l15.74,35.8c1.5,3.39,2.74,5.52,3.7,6.4a5,5,0,0,0,3.09,1.16v1.19H53.17v-1.19H54a6.54,6.54,0,0,0,3.57-.71,1.71,1.71,0,0,0,.71-1.48,4.27,4.27,0,0,0-.19-1.19c-.05-.19-.37-1-1-2.41ZM53.75,133l-6.5-15-6.7,15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.11,395.37c4.15-2.14,9-2.42,13.65-1.66,2.48.41,5.06,1.15,6.74,3s2,5.13.07,6.73a6.51,6.51,0,0,1-4.25,1.08c-3.61,0-7.61-.68-10.49,1.49-1.65,1.24-2.74,3.3-4.71,3.91A4.65,4.65,0,0,1,79,407.65a7.91,7.91,0,0,1-.58-5.86A8.93,8.93,0,0,1,83.11,395.37Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6,377c2.54,3.62,7.47,2.42,9.76.21s3.26-5.42,4.14-8.48c2-7,4-14.32,2.54-21.43a11.9,11.9,0,0,0-2.74-5.83,6.19,6.19,0,0,0-5.89-2c-2.49.65-4,3.09-5.16,5.41a51,51,0,0,0-5,21.93c0,3.53.4,7.23,2.39,10.15",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.63,382.21c2.76-3.27,3.28-8,2.05-12.14a23.3,23.3,0,0,0-7.19-10.43A38.72,38.72,0,0,0,48.62,352a13.76,13.76,0,0,0-5.79-1A6.08,6.08,0,0,0,38,354c-1.36,2.58-.06,5.72,1.35,8.28a96.78,96.78,0,0,0,8.46,12.87c2.53,3.27,5.43,6.5,9.3,8S65,384.43,67,381.75",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.43,431.7a8.25,8.25,0,0,0,.23-1.65c.12-1.2.26-2.71.44-4.5a63.76,63.76,0,0,1,1-6.59,49.32,49.32,0,0,1,2.4-7.78,28.85,28.85,0,0,1,4-7.05,14.8,14.8,0,0,1,5-4.17,14.14,14.14,0,0,1,4.24-1.32,7.69,7.69,0,0,0,1.64-.24,7.68,7.68,0,0,0-1.67,0,13,13,0,0,0-4.42,1.14,15,15,0,0,0-5.3,4.22,28,28,0,0,0-4.12,7.18,47.66,47.66,0,0,0-2.37,7.91,55.83,55.83,0,0,0-.88,6.68c-.14,1.91-.2,3.45-.22,4.52A7.3,7.3,0,0,0,73.43,431.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.74,428.24a3.32,3.32,0,0,0,0-.77v-2.18c0-1.9,0-4.65.1-8,.16-6.78.75-14.07,1.87-24.36,1.07-9.67,2.51-20.93,4-28.25.32-1.66.65-3.16,1-4.47s.54-2.45.78-3.37.38-1.56.51-2.12a3.75,3.75,0,0,0,.14-.76,2.72,2.72,0,0,0-.27.72c-.17.55-.38,1.24-.63,2.09s-.57,2-.9,3.35-.71,2.8-1.06,4.46a247.44,247.44,0,0,0-4.22,26.21c-1.13,10.31-1.64,19.7-1.68,26.5-.05,3.39,0,6.14.11,8,.06.89.1,1.61.14,2.19A3.83,3.83,0,0,0,73.74,428.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.79,410.13a17.24,17.24,0,0,0,0-2.28c-.08-1.47-.29-3.59-.7-6.19a82.2,82.2,0,0,0-2-9A74.52,74.52,0,0,0,67.29,382a56.83,56.83,0,0,0-11.07-17.24,27.7,27.7,0,0,0-2.6-2.42c-.4-.34-.76-.67-1.12-.94l-1-.7a13.9,13.9,0,0,0-1.92-1.23,68.45,68.45,0,0,1,6.3,5.62,59.69,59.69,0,0,1,10.79,17.18,84.61,84.61,0,0,1,3.8,10.56c1,3.31,1.64,6.36,2.14,8.93s.74,4.67.91,6.12A13.1,13.1,0,0,0,73.79,410.13Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "56.29 442.07 58.1 466.92 90.03 466.92 91.84 442.07 56.29 442.07",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.2,
    y: 432.27,
    width: 42.45,
    height: 9.8,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "53.2 465.97 53.2 468.68 55.2 468.68 94.95 468.68 94.95 465.97 53.2 465.97",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "57.15 473.46 55.2 468.68 93.43 468.68 91.15 473.46 57.15 473.46",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.25,450.19s0,.08-.15.23l-.48.63c-.45.58-1.07,1.38-1.86,2.38l-.08.11-.08-.11L84,447.11h.26c-1.35,1.92-2.87,4.06-4.49,6.37l-.15.2-.15-.19-5.34-6.35h.31l-.29.37c-1.66,2.07-3.26,4.08-4.77,6l-.16.2-.15-.21-4.5-6.37h.26l-5.54,6.32-.1.11-.08-.13-1.73-2.91-.45-.78c-.1-.18-.14-.27-.13-.28a1.35,1.35,0,0,1,.18.25l.5.75,1.82,2.86h-.18l5.46-6.4.14-.16.12.18c1.38,1.92,2.91,4.05,4.54,6.34h-.3l4.75-6,.3-.37.15-.19.16.19,5.32,6.36h-.3L84,446.92l.13-.19.13.19,4.48,6.39H88.6c.82-1,1.47-1.75,1.94-2.32l.52-.6C91.18,450.25,91.24,450.18,91.25,450.19Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.29,441.9c0,.11-8,.2-17.87.2s-17.87-.09-17.87-.2,8-.2,17.87-.2S92.29,441.79,92.29,441.9Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9,469c0,.11-8.69.2-19.42.2s-19.42-.09-19.42-.2,8.7-.2,19.42-.2S93.9,468.84,93.9,469Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M715.2,473.38c0,.15-152.33.26-340.18.26s-340.22-.11-340.22-.26,152.29-.26,340.22-.26S715.2,473.24,715.2,473.38Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-49"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "542.35 43.53 238.4 43.53 238.4 327.17 373.73 327.17 373.73 352.23 395.89 327.17 542.35 327.17 542.35 43.53",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.91,
    y: 43.53,
    width: 304.91,
    height: 20.56,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.32,54.49A4.47,4.47,0,1,1,249.85,50,4.47,4.47,0,0,1,254.32,54.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.19,54.49A4.47,4.47,0,1,1,262.72,50,4.47,4.47,0,0,1,267.19,54.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.06,54.49A4.48,4.48,0,1,1,275.59,50,4.47,4.47,0,0,1,280.06,54.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.35,327.41c0-1.85-.09-112.84-.23-283.88l.23.22-304,0,.26-.26V61.32c0,95.69,0,186.19,0,266.09l-.23-.23,135.33,0h.19v.2c0,8.81,0,16.93,0,24.81l-.32-.13,22.16-24.4.05-.05h.08l146.47-.24L395.88,328l.12-.06-22.14,24.42-.32.36v-.48c0-7.88,0-16,0-24.81l.2.19-135.33,0h-.24v-.24c0-79.9,0-170.4,0-266.09v-18h.26l304,0h.22v.22C542.43,214.57,542.35,325.56,542.35,327.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.92,
    y: 105.19,
    width: 46.71,
    height: 6.56,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.17,128.47c0,.14-20.84.26-46.54.26s-46.54-.12-46.54-.26,20.83-.26,46.54-.26S348.17,128.32,348.17,128.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.3,156c0,.15-14.6.27-32.61.27s-32.6-.12-32.6-.27,14.59-.26,32.6-.26S320.3,155.9,320.3,156Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.17,141.15c0,.15-20.84.26-46.54.26s-46.54-.11-46.54-.26,20.83-.26,46.54-.26S348.17,141,348.17,141.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.43,289.36H344.88V251.81h37.55Zm-36.55-1h35.55V252.81H345.88Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.81,289.36H274.26V251.81h37.55Zm-36.55-1h35.55V252.81H275.26Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.36,297.67c0,.15-9.1.26-20.33.26s-20.33-.11-20.33-.26,9.1-.26,20.33-.26S313.36,297.53,313.36,297.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.86,306c0,.15-7.9.26-17.63.26s-17.64-.11-17.64-.26,7.9-.26,17.64-.26S309.86,305.86,309.86,306Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,297.67c0,.15-9.11.26-20.34.26s-20.33-.11-20.33-.26,9.1-.26,20.33-.26S385,297.53,385,297.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.5,306c0,.15-7.89.26-17.63.26s-17.63-.11-17.63-.26,7.89-.26,17.63-.26S381.5,305.86,381.5,306Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.93,252.31c.1.1-8,8.37-18.09,18.46S345.48,289,345.38,288.86s8-8.37,18.09-18.46S381.83,252.21,381.93,252.31Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380,289.09a2,2,0,0,1-.33-.37l-.88-1.14c-.75-1-1.85-2.43-3.22-4.19-2.74-3.51-6.66-8.27-11.27-13.27s-9-9.28-12.33-12.29c-1.64-1.51-3-2.72-3.91-3.55l-1.07-1c-.23-.23-.35-.35-.34-.37a2.38,2.38,0,0,1,.41.29l1.13.89c1,.78,2.35,1.95,4,3.42,3.35,2.95,7.84,7.21,12.47,12.22a172.57,172.57,0,0,1,11.17,13.4c1.34,1.79,2.39,3.25,3.09,4.29l.8,1.19C380,288.93,380.05,289.08,380,289.09Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.53,254.53c.1.1-7.92,7.83-17.9,17.26s-18.17,17-18.27,16.88,7.92-7.83,17.91-17.26S310.43,254.43,310.53,254.53Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.13,288.69s-.14-.12-.35-.37l-.93-1.13c-.78-1-1.93-2.39-3.37-4.12-2.88-3.47-7-8.15-11.8-13s-9.45-9-12.87-12c-1.71-1.46-3.11-2.63-4.08-3.43l-1.11-.94a2.07,2.07,0,0,1-.36-.35s.16.08.43.27l1.17.86c1,.75,2.44,1.88,4.19,3.31a170.74,170.74,0,0,1,13,11.9,173.14,173.14,0,0,1,11.71,13.16c1.41,1.77,2.52,3.22,3.26,4.24l.84,1.18A2.33,2.33,0,0,1,310.13,288.69Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.59,288.8H477V251.25h37.55Zm-36.55-1h35.55V252.25H478Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449,288.8H411.43V251.25H449Zm-36.54-1H448V252.25H412.43Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.53,297.11c0,.15-9.1.26-20.33.26s-20.33-.11-20.33-.26,9.1-.26,20.33-.26S450.53,297,450.53,297.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447,305.44c0,.15-7.9.26-17.63.26s-17.64-.11-17.64-.26,7.9-.26,17.64-.26S447,305.3,447,305.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.17,297.11c0,.15-9.11.26-20.34.26s-20.33-.11-20.33-.26,9.1-.26,20.33-.26S517.17,297,517.17,297.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.66,305.44c0,.15-7.89.26-17.63.26s-17.64-.11-17.64-.26,7.9-.26,17.64-.26S513.66,305.3,513.66,305.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.09,251.75c.1.1-8,8.37-18.09,18.46s-18.36,18.19-18.46,18.09,8-8.37,18.09-18.46S514,251.65,514.09,251.75Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.19,288.53a2,2,0,0,1-.33-.37L511,287c-.75-1-1.85-2.43-3.22-4.19-2.75-3.51-6.66-8.27-11.27-13.27s-9.05-9.28-12.33-12.29c-1.64-1.51-3-2.72-3.91-3.55l-1.07-1c-.24-.23-.36-.35-.35-.37a1.88,1.88,0,0,1,.42.29l1.13.89c1,.78,2.35,2,4,3.42,3.35,3,7.83,7.21,12.46,12.22a170.74,170.74,0,0,1,11.18,13.4c1.34,1.79,2.39,3.26,3.09,4.29.32.48.59.87.8,1.2S512.21,288.52,512.19,288.53Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.7,254c.1.11-7.92,7.83-17.9,17.26s-18.17,17-18.27,16.88,7.92-7.83,17.91-17.26S447.6,253.87,447.7,254Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.29,288.13a2.52,2.52,0,0,1-.35-.37c-.24-.31-.55-.68-.92-1.12-.78-1-1.93-2.4-3.37-4.13-2.88-3.46-7-8.14-11.8-13s-9.45-9.05-12.87-12c-1.71-1.46-3.11-2.63-4.08-3.43l-1.11-.94a2.07,2.07,0,0,1-.36-.35s.16.08.43.27l1.17.86c1,.75,2.44,1.88,4.19,3.31a171.57,171.57,0,0,1,24.71,25.07c1.41,1.76,2.52,3.21,3.25,4.23l.85,1.18C447.22,288,447.31,288.12,447.29,288.13Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.66,210.32H385.4V83.06H512.66Zm-126.26-1H511.66V84.06H386.4Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.77,204.43H391V88.66H506.77Zm-114.77-1H505.77V89.66H392Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.6 202.86 392.8 202.26 426.85 156.96 450.45 170.06 480.27 124.81 481.11 125.36 450.77 171.39 427.13 158.26 393.6 202.86",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445,137.78a15.26,15.26,0,1,1,15.26-15.25A15.27,15.27,0,0,1,445,137.78Zm0-29.51a14.26,14.26,0,1,0,14.26,14.26A14.28,14.28,0,0,0,445,108.27Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.05,
    y: 156.67,
    width: 1.88,
    height: 1.88,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.55,
    y: 169.67,
    width: 1.88,
    height: 1.88,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 479.75,
    y: 124.41,
    width: 1.88,
    height: 1.88,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 444.06,
    y: 136.34,
    width: 1.88,
    height: 1.88,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 444.06,
    y: 106.72,
    width: 1.88,
    height: 1.88,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 458.87,
    y: 121.58,
    width: 1.88,
    height: 1.88,
    transform: "translate(337.29 582.34) rotate(-90)",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.25,
    y: 121.58,
    width: 1.88,
    height: 1.88,
    transform: "translate(307.67 552.72) rotate(-90)",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.25,
    y: 201.62,
    width: 1.88,
    height: 1.88,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.69,145.6c-.14,0-.26-8.64-.26-19.3s.12-19.31.26-19.31.26,8.64.26,19.31S480.83,145.6,480.69,145.6Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.39,107a.7.7,0,1,1-1.4,0,.7.7,0,0,1,1.4,0Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480.69,
    cy: 146.01,
    r: 0.7,
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.71,233.3c0,.14-52,.26-116.09.26s-116.09-.12-116.09-.26,52-.27,116.09-.27S529.71,233.15,529.71,233.3Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Images--inject-49"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "565.44 383.28 567.1 458.98 484.82 460.14 483.17 384.44 565.44 383.28",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.44,383.28l-.4,0-1.15,0-4.47.09-16.84.3-59.41,1,.21-.25c.5,22.54,1.07,48.37,1.68,75.7h0l-.24-.27,82.27-1.11-.19.23c-.46-22.8-.84-41.7-1.1-54.91-.12-6.61-.22-11.8-.28-15.35,0-1.76,0-3.12-.07-4.05s0-1.4,0-1.4,0,.45,0,1.35.07,2.26.11,4c.09,3.54.22,8.7.39,15.29.31,13.25.76,32.2,1.3,55.05v.23h-.2l-82.27,1.21h-.24v-.28h0C484,432.8,483.44,407,483,384.44v-.25h.21l59.55-.72,16.8-.17,4.43,0h1.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "487.55 456.37 564.05 455.3 562.6 389.12 486.11 390.2 487.55 456.37",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "487.55 456.37 513.37 414.86 530.49 440.36 541.41 426.45 564.05 455.3 487.55 456.37"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M536.84,410c.08,3.83-2.55,7-5.87,7s-6.09-3-6.18-6.85,2.55-7,5.87-7S536.75,406.12,536.84,410Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "544.86 376.23 546.52 451.93 464.24 453.09 462.59 377.38 544.86 376.23",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.86,376.23l-.39,0-1.16,0-4.47.09-16.84.3-59.4,1,.2-.25c.5,22.53,1.08,48.36,1.68,75.7h0l-.24-.27,82.27-1.12-.19.24c-.46-22.8-.83-41.7-1.1-54.91-.12-6.61-.22-11.8-.28-15.35,0-1.76-.05-3.12-.07-4.05s0-1.4,0-1.4,0,.45.06,1.35.06,2.26.11,4c.08,3.54.21,8.7.38,15.29.31,13.25.76,32.19,1.31,55.05v.23h-.2l-82.27,1.2H464v-.28h0c-.59-27.34-1.15-53.17-1.63-75.7v-.25h.22l59.54-.72,16.8-.17,4.43,0h1.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "466.98 448.28 543.47 447.21 542.02 381.03 465.53 382.11 466.98 448.28",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "466.98 448.28 492.8 406.77 509.91 432.28 520.83 418.36 543.47 447.21 466.98 448.28",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.26,401.4c.08,3.83-2.54,7-5.87,7s-6.09-3-6.18-6.85,2.55-7,5.88-7S516.18,397.58,516.26,401.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "466.98 448.28 492.8 406.77 509.91 432.28 520.83 418.36 543.47 447.21 466.98 448.28"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M516.26,401.4c.08,3.83-2.54,7-5.87,7s-6.09-3-6.18-6.85,2.55-7,5.88-7S516.18,397.58,516.26,401.4Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "535.94 366.61 537.59 442.31 455.32 443.47 453.67 367.76 535.94 366.61",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.94,366.61l-.4,0-1.15,0-4.47.09-16.84.3-59.41,1,.21-.25c.5,22.53,1.07,48.36,1.68,75.7h0l-.25-.28,82.28-1.11-.19.23c-.46-22.79-.84-41.69-1.1-54.9-.12-6.61-.22-11.8-.29-15.35,0-1.76,0-3.12-.06-4.05s0-1.4,0-1.4,0,.45,0,1.35.06,2.26.11,4c.09,3.53.22,8.7.39,15.29.31,13.25.76,32.19,1.3,55.05v.23h-.2l-82.27,1.2h-.24v-.28h0c-.59-27.33-1.14-53.16-1.63-75.69v-.25h.21l59.55-.72,16.8-.17,4.42,0h1.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "458.05 439.7 534.55 438.62 533.1 372.45 456.61 373.52 458.05 439.7",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "458.05 439.7 483.87 398.19 500.98 423.69 511.91 409.77 534.55 438.62 458.05 439.7"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M507.34,393.28c.08,3.83-2.55,7-5.88,7s-6.09-3-6.17-6.85,2.55-7,5.87-7S507.25,389.45,507.34,393.28Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "526.37 376.36 528.16 452.07 439.23 453.23 437.44 377.52 526.37 376.36",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.37,376.36l-.43,0-1.25,0-4.83.09-18.2.31-64.21.95.22-.24c.54,22.53,1.16,48.36,1.82,75.69h0l-.27-.27,88.93-1.11-.21.23c-.49-22.8-.9-41.69-1.18-54.91-.14-6.61-.24-11.79-.31-15.35,0-1.76-.06-3.11-.07-4s0-1.41,0-1.41,0,.45,0,1.36.07,2.26.12,4c.1,3.54.24,8.71.42,15.29.34,13.25.82,32.2,1.41,55.05v.23h-.22l-88.92,1.2H439v-.27h0c-.63-27.33-1.24-53.17-1.76-75.7v-.24h.23l64.36-.71,18.15-.17,4.79,0h1.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "442.18 448.42 524.86 447.34 523.3 381.17 440.62 382.24 442.18 448.42",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "442.18 448.42 470.09 406.91 488.58 432.41 500.39 418.5 524.86 447.34 442.18 448.42"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M495.45,401.54a6.65,6.65,0,0,1-6.34,7,6.83,6.83,0,0,1-6.68-6.85,6.65,6.65,0,0,1,6.35-7A6.82,6.82,0,0,1,495.45,401.54Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 484.58,
    y: 421.71,
    width: 83.77,
    height: 51.35,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 433.41,
    y: 421.71,
    width: 91.83,
    height: 51.35,
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M592.38,253.11l-1.16-.35c-5.43,2.24-9,7.59-10.89,13.16s-2.33,11.49-3.42,17.26-3,11.65-7,15.87a65.25,65.25,0,0,0,8.44,6.15,6.59,6.59,0,0,0,3.14,1.22c1.81.07,3.36-1.22,4.6-2.54,6.1-6.52,6.85-18.27,7.49-27.18S594.87,261.68,592.38,253.11Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M588,256.47s-13.27,46.41-12.42,47,3.49,2.21,3.49,2.21l12.1-48.55Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M596.72,245.09a4,4,0,0,0-3.58-3.54,5.72,5.72,0,0,0-4.81,2.13,10.28,10.28,0,0,0-2.09,5c-.42,2.53-.08,5.52,2,7a5.08,5.08,0,0,0,5.54-.07,7.54,7.54,0,0,0,3.08-4.82,14.74,14.74,0,0,0-.19-5.84",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.31,252.77a3.9,3.9,0,0,1-.65-1.61,10,10,0,0,1,1.58-8.06c.64-.88,1.17-1.29,1.21-1.25s-.36.56-.9,1.45a11.84,11.84,0,0,0-1.46,3.76,11.67,11.67,0,0,0-.07,4A11.63,11.63,0,0,1,592.31,252.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.37,257.06c0,.06-.26.21-.74.23a2.71,2.71,0,0,1-1.78-.62,2.68,2.68,0,0,1-.94-1.62c-.07-.48,0-.77.09-.77s.19,1.17,1.18,2S590.36,256.91,590.37,257.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "660.01 193.1 669.96 214.6 647.81 201.85 660.01 193.1",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "480.33 124.79 510.31 164.24 523.24 160.81 529.75 164.51 541 143.81 534.23 140.26 529.22 127.56 480.33 124.79",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.33,124.79l48.9,2.62h.1l0,.09,5,12.7-.07-.09,6.77,3.55.15.08-.08.15c-1.84,3.39-3.78,7-5.75,10.56l-5.51,10.14-.08.15-.15-.09-6.5-3.69h.12l-12.93,3.42-.1,0-.06-.08-29.86-39.55,30.11,39.36-.17-.05,12.93-3.44.06,0,.06,0,6.51,3.69-.23.07,5.51-10.13,5.74-10.57.07.23-6.77-3.56,0,0,0-.05-5-12.7.13.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.31,136.27a7.06,7.06,0,0,1,2.9,9.67,7.32,7.32,0,0,1-9.79,3,7.07,7.07,0,0,1-2.9-9.67A7.33,7.33,0,0,1,516.31,136.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.33,124.79c.05-.08,7.39,3.53,16.4,8.06S513,141.13,513,141.21s-7.38-3.53-16.4-8.06S480.29,124.87,480.33,124.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.62,245.61h0a11.66,11.66,0,0,1-15.55,4.82L536,167.18,547,147l162.93,83.2A11.24,11.24,0,0,1,714.62,245.61Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "548.99 145.87 536.07 169.62 527.81 165.29 540.72 141.53 548.99 145.87",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "536.95 168.01 547.93 147.81 551.01 149.41 538.05 168.58 536.95 168.01"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "531.35 158.78 543.29 155.82 545.22 152.8 532.94 155.84 531.35 158.78",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M648.65,199.63a24.23,24.23,0,0,1,.61,25.63Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M618.48,454.48c.1.2,1.07-.12,2.29-.06s2.17.42,2.28.23-.82-.93-2.25-1S618.37,454.32,618.48,454.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.8,437.89c.17.12.87-.64,2-1.19s2.09-.72,2.09-.93-1.17-.41-2.44.27S615.62,437.8,615.8,437.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.63,437.26l1.29,22.62s-22.56,8.91-22.73,13.11l43.95-.92-.56-35.33Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.47,457.69a1.8,1.8,0,0,1,1.29,2,1.73,1.73,0,0,1-2,1.29,1.9,1.9,0,0,1-1.35-2.15,1.81,1.81,0,0,1,2.23-1.11",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.2,473.2v-4.71l-42.32,2.23s-1.94.9-1.69,2.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.2,459.67c0,.22,1.09.29,2.16,1s1.65,1.56,1.85,1.47-.15-1.32-1.46-2.11S618.15,459.48,618.2,459.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.63,461.67c0,.21.9.56,1.65,1.45s1,1.85,1.19,1.84.32-1.23-.63-2.33S613.64,461.47,613.63,461.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.13,467.25c.2,0,.47-1-.1-2.2s-1.59-1.61-1.68-1.43.55.79,1,1.76S610.92,467.23,611.13,467.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.78,237s10,17.25,11.41,32.69c1.25,14-7.58,30-7.58,30l-15.26,57.46,4.5,98.26-24.41,1.25L602.36,344l4.26-104.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.5,423.36l12.36,19S603.7,461.29,605.65,465l37.68-22.63-18-30.38Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.53,433.72a1.79,1.79,0,0,1,2.12,1.12,1.73,1.73,0,0,1-1.09,2.11,1.9,1.9,0,0,1-2.24-1.19,1.79,1.79,0,0,1,1.38-2.07",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.33,442.39l-1.94-3L606,462.22s-1.24,1.74-.34,2.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.13,442.53c.12.18,1.09-.29,2.35-.24s2.21.53,2.33.36-.78-1.08-2.31-1.11S618,442.39,618.13,442.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.16,446.54c.07.2,1.05,0,2.14.44s1.77,1.12,2,1-.33-1.23-1.7-1.7S615.06,446.36,615.16,446.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.76,452.62c.19-.06-.11-1.14-1.18-1.86s-2.18-.61-2.17-.41.87.42,1.75,1S615.56,452.71,615.76,452.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.72,243.91S565,350.74,571.4,362.7s39.14,78.54,39.14,78.54l27.52-15.15-31.44-73.45,23.9-52.57s11.45-10,15.88-23.93-3.22-37-3.22-37H595.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.78,261.36s.08.27.18.82.26,1.37.4,2.44A60.4,60.4,0,0,1,649,274a37.54,37.54,0,0,1-.74,6.71,21.27,21.27,0,0,1-1.12,3.69,24,24,0,0,1-1.92,3.68A30.67,30.67,0,0,1,630.6,300.3l.14-.13-23.85,52.59v-.23l1.37,3.19C620,383.19,630.59,408,638.25,426l.07.17-.16.09-20.18,11-5.5,3L611,441a5.28,5.28,0,0,1-.5.24L611,441l1.41-.81,5.45-3.06L638,425.91l-.09.26c-7.71-17.95-18.37-42.77-30.15-70.22l-1.37-3.19-.05-.12.05-.12L630.3,300l0-.09.1,0a30.41,30.41,0,0,0,14.4-11.94,24.16,24.16,0,0,0,1.92-3.6,21.56,21.56,0,0,0,1.12-3.63,37.89,37.89,0,0,0,.79-6.65,65.29,65.29,0,0,0-.45-9.38c-.12-1.07-.25-1.89-.33-2.44S647.78,261.36,647.78,261.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.62,263.13a4.17,4.17,0,0,1,.56-.07l1.67-.12,6.4-.43,22.86-1.41.28,0v.28c0,6.73,0,14.29,0,22.3v.14l-.1.09c-1.1.93-2.26,1.93-3.44,2.94l-11.72,10L623,297l-.16-.08-15.24-7.61-.13-.07v-.14c-.27-7.82-.51-14.32-.67-18.91-.07-2.21-.12-4-.16-5.22,0-.56,0-1,0-1.36a.31.31,0,1,1,.06.05c0,.36.05.82.09,1.4.07,1.27.16,3,.28,5.27.23,4.56.54,11,.92,18.75l-.13-.21,15.27,7.54-.31,0,11.71-10c1.17-1,2.34-2,3.44-2.94l-.11.22c0-8,0-15.57,0-22.3l.28.26-22.71,1.14-6.47.3-1.72.06C606.84,263.13,606.63,263.14,606.62,263.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638,265.54a4.85,4.85,0,0,1-1.22.25c-.79.13-1.93.29-3.35.46-2.83.34-6.76.73-11.11,1s-8.3.37-11.15.38c-1.43,0-2.59,0-3.38,0a5.37,5.37,0,0,1-1.24-.1,4.77,4.77,0,0,1,1.23-.13l3.38-.15c2.85-.11,6.78-.28,11.12-.55s8.27-.59,11.11-.82l3.37-.28A5.14,5.14,0,0,1,638,265.54Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.45,189.53a39.69,39.69,0,0,0-3.11,19.1c.45,4.19,2.91,14.86,2.91,14.86l-.33,20.42s54.16-4.06,54.11-4.17.59-25.71.1-43.71-8.4-36.53-8.4-36.53-7.21-4.16-12.61-3.7-28.07,3-28.07,3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.17,159.47s-9,1.31-17.43,14.48c-8.67,13.61-12.64,19.24-12.64,19.24l24.69,16.13s13.62-20.52,15.32-24.92S612.71,159.06,599.17,159.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.38,158.09s7.81,3.09,11,8.07c2.1,3.23,15,25.94,15,25.94l-14.86,10.34-11.21-31.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M591.88,212.2l2.86,1.29s13.5-17.9,14-28l-14.83,23-2.49-1.32Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M647.08,174a1.8,1.8,0,0,1,.12.51l.22,1.46c.18,1.27.42,3.11.67,5.39.51,4.56,1,10.87,1.41,17.86s.48,13.33.52,17.91c0,2.3,0,4.15,0,5.43,0,.6,0,1.08,0,1.48a1.65,1.65,0,0,1-.05.52,3.08,3.08,0,0,1,0-.52c0-.4,0-.88-.06-1.47,0-1.36-.09-3.2-.15-5.43-.13-4.58-.3-10.91-.67-17.89s-.85-13.29-1.26-17.86c-.21-2.22-.38-4-.5-5.4-.05-.59-.09-1.07-.13-1.47A2.92,2.92,0,0,1,647.08,174Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.14,133c-1.13-5.77-3.51-11.2-5.32-16.79-2.11-6.51-3.75-13.73-9-18.11-3.46-2.9-8-4.09-12.44-5-4-.82-8.16-1.45-12.17-.62-2,.42-3.91,1.19-5.89,1.67-2.31.56-4.74.73-6.89,1.72-4.45,2-6.72,7.13-7.39,12s-.12,9.82-.81,14.67c-.34,2.32-1,4.6-1.52,6.88-2.05,4.43-4.3,8.86-4,13.6.23,3.43,1.81,6.62,2.56,10s.45,7.39-2.26,9.5a4.94,4.94,0,0,0,8.29-3.27,3.55,3.55,0,0,0,1.36,1.13,8.57,8.57,0,0,0,4.42.34c4.31-.41,8.79-.91,12.54-3l21.11-1.8c5.45,2.21,12-.85,15.16-5.82S644.28,138.75,643.14,133Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.33,97c-2,.41-4.2.11-6.2.67-2.91.82-5.07,3.38-6.18,6.19a29.58,29.58,0,0,0-1.54,8.89l-.57,8.09a25.46,25.46,0,0,1-.72,5.16c-.53,1.87-2,6.83-2.08,9.25a26.14,26.14,0,0,0,6,18.3c1.86,2.11,10.53,2.16,13.29,2.72,1.21-1.06,4.25-1.05,5.47-2.12.2-.18-8.83-7.08-8.72-7.33a1.87,1.87,0,0,0-.12-1.31,64.54,64.54,0,0,1,2.72-48.07",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.76,158.78l3.16-49.62h0a4.15,4.15,0,0,0-3.71-4.22l-22-5.62c-7.06-.76-11.78,7.92-12.24,15-.51,7.87-.83,17.5.09,23.38,1.85,11.81,10.9,13.33,10.9,13.33s.75,7.93.75,7.93,5.73-1,10-1.46C621,156.5,624.76,158.78,624.76,158.78Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.68,123.15a1.51,1.51,0,0,0,1.45,1.53,1.45,1.45,0,0,0,1.57-1.36,1.53,1.53,0,0,0-1.46-1.54A1.46,1.46,0,0,0,592.68,123.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.7,119.68c.19.2,1.34-.65,3-.64s2.82.83,3,.63-.11-.45-.63-.83a4.07,4.07,0,0,0-2.4-.74,4,4,0,0,0-2.36.75C592.78,119.24,592.61,119.59,592.7,119.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.65,123.35a1.51,1.51,0,0,0,1.45,1.53,1.45,1.45,0,0,0,1.57-1.36,1.52,1.52,0,0,0-1.46-1.54A1.46,1.46,0,0,0,607.65,123.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.72,119.68c.19.2,1.34-.65,3-.64s2.82.83,3,.63-.1-.45-.63-.83a4.07,4.07,0,0,0-2.4-.74,4,4,0,0,0-2.36.75C608.8,119.24,608.63,119.59,608.72,119.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.78,131.76a11.16,11.16,0,0,0-2.65-.49c-.41,0-.81-.12-.88-.41a2.11,2.11,0,0,1,.28-1.23c.4-1,.81-2.06,1.24-3.17,1.72-4.51,3-8.21,2.78-8.28s-1.72,3.53-3.44,8c-.41,1.11-.81,2.17-1.19,3.19a2.45,2.45,0,0,0-.22,1.63,1.06,1.06,0,0,0,.69.61,2.74,2.74,0,0,0,.7.1A11,11,0,0,0,602.78,131.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.93,151a31.79,31.79,0,0,0,16.51-4.18s-4.34,9-16.16,7.85Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.27,135.2a3.05,3.05,0,0,0-2.13-1.15,3.41,3.41,0,0,0-3,1.25l-.08.06a.64.64,0,0,0,0,.7,1.92,1.92,0,0,0,.54.56,7,7,0,0,0,2.4,1.44,2.28,2.28,0,0,0,2.47-.61A2,2,0,0,0,608.27,135.2Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.57,132.9c-.26,0-.27,1.75-1.79,3s-3.4,1.06-3.41,1.3.42.35,1.21.37a4.41,4.41,0,0,0,2.85-1,3.83,3.83,0,0,0,1.39-2.53C607.89,133.33,607.69,132.89,607.57,132.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.72,113.86c.16.44,1.79.23,3.7.47s3.46.76,3.72.36c.11-.19-.16-.61-.78-1a6.19,6.19,0,0,0-2.75-1,6.34,6.34,0,0,0-2.9.34C608,113.3,607.66,113.65,607.72,113.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.67,114.5c.29.37,1.41,0,2.76,0s2.5.25,2.76-.13c.12-.19-.06-.56-.56-.91a4,4,0,0,0-4.45.13C592.71,113.93,592.55,114.32,592.67,114.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.7,161.35a3.28,3.28,0,0,1-.24-.69c-.13-.46-.31-1.15-.5-2a37.86,37.86,0,0,1-.79-7.71,40.88,40.88,0,0,1,1.66-11.38c1.12-4.17,2.82-8.63,3.59-13.52s.53-9.68,1.14-14,1.92-8.14,4-10.73a12.53,12.53,0,0,1,6.35-4.37,7.1,7.1,0,0,1,2.83-.29,13.9,13.9,0,0,0-2.77.51,12.69,12.69,0,0,0-6.09,4.4,21.55,21.55,0,0,0-3.8,10.55c-.58,4.25-.36,9-1.1,14s-2.51,9.44-3.65,13.58a41.43,41.43,0,0,0-1.76,11.23,41,41,0,0,0,.6,7.67c.15.9.29,1.59.39,2.06A3.27,3.27,0,0,1,582.7,161.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.86,98.53a2.84,2.84,0,0,1,1.21-1.65A16.76,16.76,0,0,1,612.89,94a29.91,29.91,0,0,1,12.31,5.34c3.22,2.23,6.27,5,7.91,8.53a28.32,28.32,0,0,1,1.91,8.06c.93,6.81,2.76,13.63,2.69,20.5,0,2.68.46,7.18,0,10.48-.48,3.52-3.9,7.82-7.37,8.61l-7.83.78s4.24-14.61,3.91-19.87c-.28-4.61-.24-9.67-.76-14.26a2.4,2.4,0,0,0-.28-1,2.53,2.53,0,0,0-1.07-.83l-4.89-2.5a48.89,48.89,0,0,1-4.59-2.56,41.17,41.17,0,0,1-4.62-3.19c-2.11-1.8-4.05-3.25-6.16-5.05a24.88,24.88,0,0,1-3.85-4.59,6.35,6.35,0,0,1-1.05-5",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.1,125.34a3.44,3.44,0,0,1,5-2.93c1.2.69,2.11,2.08,2,4.75-.29,7.11-7.37,5.35-7.38,5.15S625,128.28,625.1,125.34Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.05,129.7s.12.09.32.2a1.28,1.28,0,0,0,.93.06,3.1,3.1,0,0,0,1.53-2.7,4,4,0,0,0-.27-1.79,1.47,1.47,0,0,0-.89-1,.64.64,0,0,0-.75.31c-.1.2-.06.34-.1.35s-.15-.12-.08-.41a.75.75,0,0,1,.3-.44.93.93,0,0,1,.69-.15,1.73,1.73,0,0,1,1.25,1.15,4.25,4.25,0,0,1,.35,2c-.11,1.43-.9,2.74-1.94,3a1.31,1.31,0,0,1-1.12-.23C627.05,129.87,627,129.71,627.05,129.7Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.9,114.14a24.84,24.84,0,0,0-4.93-3,37,37,0,0,0-6-2c-2.3-.62-4.87-1.17-7.51-2A38.2,38.2,0,0,1,606,100.57a33.19,33.19,0,0,1-3.2-2.86,7,7,0,0,1-1-1.18,8.93,8.93,0,0,1,1.19,1c.75.67,1.85,1.62,3.29,2.69a41,41,0,0,0,12.41,6.34c2.61.81,5.18,1.38,7.48,2a35.34,35.34,0,0,1,6,2.14,17.06,17.06,0,0,1,3.63,2.29,9.39,9.39,0,0,1,.86.8C636.83,114,636.92,114.13,636.9,114.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.87,104.94c2.72,8.8,7.16,16.84,9.89,23.19,1.27,2.94,3.09,6.41,3.67,9.56.64,3.46-.84,6.9-1.66,10.32s-.7,7.64,2.14,9.71a22.69,22.69,0,0,1-13.43,4.84,4.14,4.14,0,0,1-2.62-.57,1.65,1.65,0,0,1-.4-2.37,11.66,11.66,0,0,1-14.79,1.53c-.32-3.79-.57-7.91,1.52-11.1,1.71-2.6,4.8-4.24,5.92-7.14.67-1.73-.21-3.9.08-5.74s1.51-4.27,2.06-4.52h0a9,9,0,0,0,9.61-6.65l.15-.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.14,155.88a3.84,3.84,0,0,1,.37-.72l1.12-2a51.22,51.22,0,0,0,3.44-7.73,31.43,31.43,0,0,0,1.79-12.3,21.88,21.88,0,0,0-5.75-13.78c-3.77-3.93-8.57-6.23-12.84-8.21A95.33,95.33,0,0,1,609,105.51a26.44,26.44,0,0,1-6.53-5.47,15.21,15.21,0,0,1-1.37-1.87,3.9,3.9,0,0,1-.4-.7c.06,0,.62.93,1.94,2.42a27.93,27.93,0,0,0,6.58,5.27,102.56,102.56,0,0,0,11.32,5.47c4.29,2,9.16,4.26,13,8.3a22.27,22.27,0,0,1,5.86,14.15,31.4,31.4,0,0,1-1.93,12.47,46.13,46.13,0,0,1-3.64,7.7c-.51.87-.93,1.53-1.22,2A5.06,5.06,0,0,1,632.14,155.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.17,183c-.09-.05.6-1.27,1.12-3.44a16.12,16.12,0,0,0-4.79-15.79c-1.64-1.51-2.9-2.14-2.85-2.23a3.78,3.78,0,0,1,.9.41,14.18,14.18,0,0,1,2.19,1.55,15.6,15.6,0,0,1,4.91,16.15,12.8,12.8,0,0,1-1,2.51A3.83,3.83,0,0,1,610.17,183Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.28,252.67l23.24.51a2,2,0,0,1,1.93,2c-.47,11.52-2.59,68.7,2.15,69.59,5.28,1,10.87-9.07,18.63-5.57s16.95,7.44,21.28,3.06,7.8-55.08-9.48-82.82l-55,3.15Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.91,246.36a5.33,5.33,0,0,1-1.14,0l-3.1-.06c-2.62,0-6.23,0-10.22.26s-7.56.75-10.15,1.16l-3.06.49a4.33,4.33,0,0,1-1.13.13,5.12,5.12,0,0,1,1.09-.33c.71-.18,1.75-.41,3-.66A87.57,87.57,0,0,1,615.68,246c1.31.07,2.37.15,3.1.23A4.5,4.5,0,0,1,619.91,246.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.61,252.81a11.21,11.21,0,0,1-1.61-.25c-1-.2-2.52-.48-4.36-.79-3.68-.64-8.8-1.38-14.49-1.83s-10.85-.5-14.59-.45c-1.87,0-3.39.07-4.43.11a8.91,8.91,0,0,1-1.63,0,10.86,10.86,0,0,1,1.62-.19c1-.1,2.56-.2,4.43-.27a126.22,126.22,0,0,1,14.64.29,128.53,128.53,0,0,1,14.52,2c1.84.37,3.32.7,4.33,1A8.36,8.36,0,0,1,631.61,252.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.75,273.21a7.73,7.73,0,0,1,0,1.49c0,1.05-.1,2.41-.17,4-.13,3.42-.21,8.14-.05,13.35s.56,9.92.91,13.32c.17,1.63.31,3,.43,4a7.45,7.45,0,0,1,.1,1.48,8.6,8.6,0,0,1-.3-1.46c-.17-.94-.38-2.31-.6-4-.44-3.39-.89-8.11-1.06-13.34s0-10,.2-13.38c.11-1.71.23-3.1.34-4.05A8.71,8.71,0,0,1,640.75,273.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.28,308.31c-.15,0-1.1-10.24-2.14-22.9s-1.77-22.92-1.62-22.93,1.1,10.23,2.14,22.89S648.42,308.3,648.28,308.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.83,194.92l-2,2.67L569.1,184l-13.69-4.6s-3.22,34.12-2.73,39.42c.54,5.78.65,6.07,2.12,8.7,1.88,3.38,8.41,5.73,12.14,4.74s7.74-6.07,10.72-9.11c5.43-5.51,13.8-16,13.8-16Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.83,194.92a16.21,16.21,0,0,1-1.5,2.28c-1,1.38-2.26,3.3-3.6,5.48s-2.49,4.19-3.3,5.67a16,16,0,0,1-1.37,2.35,12.83,12.83,0,0,1,1-2.52A64.5,64.5,0,0,1,570,197,12.08,12.08,0,0,1,571.83,194.92Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.33,181.15l-5.34-3c-2.14-1.7-4.11-3.37-4.62-6.06h0s15.55,6.95,16.79,7.59,7.11,3,6.93,5.43Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M611.05,245.29c5.75-.13,11.51-.1,17.25.27,1.16.07,2.68.53,2.64,1.69a1.56,1.56,0,0,1-1.15,1.3,4.39,4.39,0,0,1-1.84.06L612.62,247A46,46,0,0,0,592,248.54l-.21-1.26S607.81,245.37,611.05,245.29Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-49"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "146.51 152.91 188.31 152.91 187.6 179.43 154.01 187.08 146.51 152.91",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.81,437.44,131,456.36s16.61,14.28,15.5,17.92l-37.22-13.81,10.95-30Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M138.81,437.44,131,456.36s16.61,14.28,15.5,17.92l-37.22-13.81,10.95-30Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M120.09,450.47a1.62,1.62,0,0,0-1.69,1.35,1.57,1.57,0,0,0,1.32,1.69,1.71,1.71,0,0,0,1.78-1.44c0-.79-.77-1.71-1.56-1.6",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.29,460.47l1.22-3,35.23,14.35s1.39,1.34.77,2.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.68,456.39c-.07.18-1-.08-2.12.18s-1.88.84-2,.7.52-1.08,1.87-1.36S131.78,456.24,131.68,456.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,459.45c0,.2-.93.21-1.83.75s-1.39,1.29-1.56,1.21.08-1.14,1.22-1.79S135.05,459.28,135,459.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.47,465c-.18,0-.1-1,.74-1.85s1.83-.9,1.85-.72-.7.52-1.38,1.2S135.66,465,135.47,465Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,451.88c-.14.14-.88-.42-1.93-.73s-2-.29-2-.48,1-.55,2.21-.17S133.12,451.77,133,451.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.94,440.66l-.62,21.56s21.71,7.87,22,11.87l-41.85.3L99,440.76Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.37,460.5a1.72,1.72,0,0,0-1.17,2,1.64,1.64,0,0,0,1.93,1.18,1.81,1.81,0,0,0,1.23-2.08,1.71,1.71,0,0,0-2.15-1",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.43,475.28l0-3.26,40.25,0s1.87.79,1.67,2.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,462c0,.2-1,.3-2,1s-1.53,1.53-1.72,1.45.11-1.26,1.34-2S120,461.82,120,462Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.4,463.79c0,.2-.83.55-1.52,1.42S122,467,121.8,467s-.35-1.16.53-2.23S124.4,463.59,124.4,463.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.93,469c-.18.05-.47-1,0-2.09s1.47-1.58,1.56-1.41-.5.77-.91,1.7S127.14,469,126.93,469Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.59,457.08c-.08.18-1-.09-2.17,0s-2.06.46-2.16.29.75-.91,2.11-1S119.69,456.91,119.59,457.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.44,249.56s17.07,68.93,19.88,91.05c2,15.4-1.9,25.54-2.36,28.62a8.83,8.83,0,0,1-1,2.95l-36.88,71.54-25.49-8.84s19.1-57.69,23.28-67l4.7-8.35-37.19-94.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.33,264.43c.47,1.89-21.93,112.73-21.93,112.73l2.88,79.4-23.56.64s-12.06-43.26-12.53-68.79,2.41-29.88.32-45.82c-2.2-16.8-15.68-51.41-9.57-74.89,5.11-19.63,18.29-29.08,18.29-29.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.3,457.23a2.56,2.56,0,0,0,0-.41c0-.3,0-.7,0-1.2,0-1.08-.06-2.63-.11-4.61-.11-4-.29-9.85-.5-17.05-.48-14.5-1.15-34.59-1.9-57.18v.07c.54-2.71,1.12-5.59,1.7-8.5,4.74-24.15,9-46,12.15-61.87,1.52-7.9,2.76-14.3,3.62-18.77.41-2.19.72-3.9.95-5.1.1-.56.17-1,.23-1.33a2.74,2.74,0,0,0,.06-.46,2.88,2.88,0,0,0-.12.44c-.08.33-.17.77-.3,1.32-.25,1.2-.61,2.91-1.06,5.09-.91,4.45-2.21,10.84-3.81,18.72-3.17,15.85-7.52,37.7-12.34,61.83l-1.69,8.51v.07c.83,22.59,1.57,42.68,2.11,57.17.29,7.2.53,13,.69,17,.1,2,.17,3.52.22,4.61,0,.5,0,.89.07,1.19A1.91,1.91,0,0,0,121.3,457.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.35,358c-.14.07,1,2.23,3.33,4a9.34,9.34,0,0,0,4.74,2.14c.06-.18-2.13-.93-4.36-2.64S140.51,357.92,140.35,358Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.82,88.25a9.38,9.38,0,0,0-10.22-.8,13.53,13.53,0,0,0-6.36,8.46,11.2,11.2,0,0,0-.26,5.57,6.6,6.6,0,0,0,3.25,4.38,4.84,4.84,0,0,1,2.06,1.33c.86,1.34-.51,3.14-.08,4.68a2.77,2.77,0,0,0,3.21,1.65,6.64,6.64,0,0,0,3.3-2.08,25.47,25.47,0,0,0,7.14-15A7.45,7.45,0,0,0,93.82,88.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.86,437.71l-70.28-2.56a14.19,14.19,0,0,1-13.83-14.67l11.31-266.57a14.41,14.41,0,0,1,15-13.61l70.28,2.56a14.2,14.2,0,0,1,13.84,14.66L263.9,424.09A14.41,14.41,0,0,1,248.86,437.71Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.86,437.71l.51,0A14.54,14.54,0,0,0,262.62,429a15.11,15.11,0,0,0,1.17-5.78q.12-3.19.27-6.8c.78-19.24,1.92-47.05,3.32-81.41s3.14-75.29,5-120.72q.7-17,1.46-34.9.38-8.91.76-18c.09-3,.52-6.1-.59-8.91a13.92,13.92,0,0,0-9.68-8.78,21.42,21.42,0,0,0-4.64-.5l-9.58-.35-19.41-.7-39.64-1.44a14.43,14.43,0,0,0-9.1,2.84,13.94,13.94,0,0,0-5.15,7.81,23.1,23.1,0,0,0-.46,4.74c-.07,1.62-.14,3.23-.2,4.83-.14,3.22-.28,6.42-.41,9.62q-.83,19.15-1.61,37.71c-1.06,24.73-2.08,48.58-3,71.31-2,45.44-3.73,86.36-5.22,120.73-.19,4.29-.37,8.49-.55,12.57-.09,2.05-.18,4.06-.26,6.05a16.3,16.3,0,0,0,.4,5.77,14,14,0,0,0,6.78,8.48,14.32,14.32,0,0,0,5.09,1.63c1.75.19,3.56.17,5.29.26l35.75,1.38,22.59.9,5.87.25c1.33.06,2,.12,2,.12s-.68,0-2,0L241,437.5l-22.59-.74-35.76-1.24c-1.75-.08-3.5,0-5.33-.24A14.76,14.76,0,0,1,172,433.6a14.49,14.49,0,0,1-7.05-8.77,16.87,16.87,0,0,1-.43-5.93c.08-2,.16-4,.25-6,.17-4.08.34-8.28.52-12.57,1.43-34.37,3.14-75.3,5-120.74,1-22.72,2-46.58,3-71.31q.78-18.54,1.59-37.71c.14-3.2.27-6.4.41-9.62.07-1.6.13-3.21.2-4.83a24.29,24.29,0,0,1,.48-4.9,14.76,14.76,0,0,1,5.46-8.28,15.31,15.31,0,0,1,9.64-3l39.65,1.44,19.4.71,9.59.35a21.93,21.93,0,0,1,4.81.52,14.89,14.89,0,0,1,4.43,2,14.41,14.41,0,0,1,5.81,7.35,13.35,13.35,0,0,1,.8,4.63c0,1.56-.11,3-.16,4.58q-.39,9.11-.77,18-.76,17.84-1.5,34.89c-2,45.44-3.73,86.36-5.21,120.73s-2.75,62.16-3.59,81.39c-.11,2.4-.22,4.67-.31,6.8a15.25,15.25,0,0,1-1.23,5.87,14.32,14.32,0,0,1-6.37,6.86,13.93,13.93,0,0,1-5.61,1.69,10.6,10.6,0,0,1-1.5.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.09 208.02 177.89 204.7 179.84 158.93 271.03 162.25 269.09 208.02",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.33 272.84 175.14 269.52 177.09 223.75 268.28 227.07 266.33 272.84",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.58 337.66 172.39 334.34 174.33 288.57 265.52 291.89 263.58 337.66",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "260.83 402.48 169.64 399.16 171.58 353.39 262.77 356.71 260.83 402.48",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "269.09 208.02 177.89 204.7 179.84 158.93 271.03 162.25 269.09 208.02"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "266.33 272.84 175.14 269.52 177.09 223.75 268.28 227.07 266.33 272.84"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "263.58 337.66 172.39 334.34 174.33 288.57 265.52 291.89 263.58 337.66"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "260.83 402.48 169.64 399.16 171.58 353.39 262.77 356.71 260.83 402.48"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M247.52,438.49l-68.18.71c-7.3.07-13.28-6.12-13.35-13.83l-2.58-275.53c-.07-7.71,5.79-14,13.1-14.1l68.18-.71c7.31-.08,13.28,6.11,13.36,13.83l2.57,275.52C260.69,432.09,254.83,438.41,247.52,438.49Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.52,438.49s.66,0,1.9-.23a12.56,12.56,0,0,0,5.16-2.13,13.8,13.8,0,0,0,5.33-7.51,18.14,18.14,0,0,0,.55-6.05q0-3.3-.08-7c-.22-19.83-.53-48.48-.91-83.89s-.78-77.58-1.25-124.4q-.17-17.57-.35-36-.09-9.19-.18-18.57c0-1.56,0-3.16-.08-4.68a14.39,14.39,0,0,0-1-4.44,13.59,13.59,0,0,0-5.83-6.63,12.24,12.24,0,0,0-4.17-1.4,30.28,30.28,0,0,0-4.49-.12l-9.16.1-18.55.19-37.88.4a12.53,12.53,0,0,0-8.45,3.48,13.67,13.67,0,0,0-4.16,8.45c-.17,1.59-.07,3.28-.08,4.93l0,5q0,5,.09,9.91.18,19.74.36,38.87c.23,25.48.45,50.06.66,73.48.41,46.83.77,89,1.08,124.42q0,6.65.1,13c0,2.11,0,4.18,0,6.23a16.86,16.86,0,0,0,.75,5.89,13.52,13.52,0,0,0,7.16,8.09c3.24,1.58,6.79,1,10.1,1.06l34.16-.29,21.59-.14,5.62,0c1.26,0,1.91,0,1.91,0l-1.91.06-5.61.1-21.59.3-34.17.43-5.08.05a12.51,12.51,0,0,1-5.2-1.11,14,14,0,0,1-7.46-8.38,17.17,17.17,0,0,1-.79-6.06q0-3.08-.07-6.24-.06-6.31-.13-13c-.36-35.41-.78-77.59-1.25-124.41-.22-23.42-.46-48-.71-73.48q-.18-19.11-.37-38.87,0-4.93-.09-9.91l-.05-5c0-1.66-.09-3.31.08-5a14.51,14.51,0,0,1,4.42-9,13.35,13.35,0,0,1,9-3.7l37.89-.39,18.54-.19,9.16-.09a31.08,31.08,0,0,1,4.61.12,13.14,13.14,0,0,1,4.42,1.49,14.46,14.46,0,0,1,6.19,7.05,15.44,15.44,0,0,1,1.06,4.7c.09,1.62.05,3.15.08,4.73q.09,9.38.17,18.57.17,18.38.32,36c.41,46.82.77,89,1.08,124.41s.5,64.06.65,83.88c0,2.48,0,4.82.05,7,0,1.1,0,2.16-.05,3.2-.07.51-.14,1-.2,1.51s-.22,1-.35,1.42a13.88,13.88,0,0,1-5.47,7.58,12.45,12.45,0,0,1-5.24,2.08,10.75,10.75,0,0,1-1.42.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "254.74 201.6 167.71 202.5 167.26 155.41 254.3 154.5 254.74 201.6",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.36 268.31 168.33 269.22 167.89 222.12 254.92 221.21 255.36 268.31",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.99 335.02 168.95 335.93 168.51 288.83 255.54 287.93 255.99 335.02",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.61 401.74 169.57 402.64 169.13 355.55 256.17 354.64 256.61 401.74",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "255.36 268.31 168.33 269.22 167.89 222.12 254.92 221.21 255.36 268.31",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "255.99 335.02 168.95 335.93 168.51 288.83 255.54 287.93 255.99 335.02",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "256.61 401.74 169.57 402.64 169.13 355.55 256.17 354.64 256.61 401.74",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M249.66,425a11.06,11.06,0,1,1-8.4-13.2A11.05,11.05,0,0,1,249.66,425Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.66,425c-.09,0,.17-1,.09-2.71a11.09,11.09,0,0,0-2.68-6.63,10.77,10.77,0,0,0-9.59-3.63,10.56,10.56,0,0,0-5.62,2.57,10.63,10.63,0,0,0-2.73,12.29,10.58,10.58,0,0,0,4,4.71,10.75,10.75,0,0,0,10.22.76,11,11,0,0,0,5.22-4.87c.81-1.54,1-2.52,1.07-2.49a2,2,0,0,1-.1.7,8.4,8.4,0,0,1-.67,1.93,11,11,0,0,1-5.27,5.28,11.16,11.16,0,0,1-5.13,1.09,11.41,11.41,0,0,1-5.76-1.74,11.26,11.26,0,0,1-4.36-5A11.39,11.39,0,0,1,231.31,414a11.2,11.2,0,0,1,6.07-2.72,11.26,11.26,0,0,1,10.15,4,11.09,11.09,0,0,1,2.55,7,9,9,0,0,1-.21,2A2.33,2.33,0,0,1,249.66,425Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.22,207.15l-1,.85a.59.59,0,0,1-.38.18c-.18,0-.31-.17-.39-.33a2.33,2.33,0,0,1-.06-1.85,3.94,3.94,0,0,1,1.1-1.52,1.14,1.14,0,0,1,.78-.36,1.17,1.17,0,0,1,.72.44,11,11,0,0,1,.78.89.61.61,0,0,1,.19.51.67.67,0,0,1-.26.34c-.43.35-1.05.5-1.49.85",
    style: {
      fill: "#8e4842"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.91,190.38c1.42-.06,7.8-.72,7.8-.72l10.68,2.57a3.7,3.7,0,0,1-3.06,1.9c-2.85-.06-6.83-.36-6.83-.36l-1.26.75s4.84,3.26,4.89,3.91a2.82,2.82,0,0,1-.34,1.35,5.06,5.06,0,0,1,.13,3.54l-.16,4.55L187.17,211a3.64,3.64,0,0,1-.37-2.46c.32-1.28,2.08-2,2.08-2l-1.06-1.9-1.61-.58s-10.55,3-13,2.77L164.79,211l-1.18-12.33S178.5,190.43,179.91,190.38Z",
    style: {
      fill: "#b2655f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.28,200c-.05.13,1.29.68,2.8,1.61s2.61,1.87,2.7,1.77a6.94,6.94,0,0,0-2.46-2.15A7.2,7.2,0,0,0,186.28,200Z",
    style: {
      fill: "#8e4842"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.45,196.39a30.05,30.05,0,0,0,3.05,1.74,27.55,27.55,0,0,0,3,1.76,9.16,9.16,0,0,0-2.81-2.15A9,9,0,0,0,185.45,196.39Z",
    style: {
      fill: "#8e4842"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.17,191.22a18.94,18.94,0,0,0,2.51,1.89,8.41,8.41,0,0,0,2.74,1.57,16.72,16.72,0,0,0-2.48-1.93A7.92,7.92,0,0,0,182.17,191.22Z",
    style: {
      fill: "#8e4842"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.29,135.39a13.88,13.88,0,0,0-2.06-3.27,2.71,2.71,0,0,0-2.72-.51l-.65.38s-2.61-1.86-4.19-1.14c0,0-2.47-1.83-4.07-.62,0,0-1.83-1.78-3-.77a5,5,0,0,0-1.21,4.18c.22,1.12.33,4.82.94,5,0,0,1.64.51,2-.35S202,137,202,137s0,3.34.75,3.65,2.23.52,2.56-.88c0,0,.5,1.21,1.26,1s1.73-.51,1.83-1.4.25-1.76.25-1.76.13,1.35.82,1.2,1.32,0,1.89-1,1.9-2.94,1.9-2.94Z",
    style: {
      fill: "#b2655f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.72,137.61s-.06-.37-.09-1a5.25,5.25,0,0,1,.35-2.24,5.13,5.13,0,0,1,1.28-1.86c.44-.41.76-.6.73-.64a2.06,2.06,0,0,0-.86.48,4.69,4.69,0,0,0-1.42,1.92,4.58,4.58,0,0,0-.28,2.36A2,2,0,0,0,208.72,137.61Z",
    style: {
      fill: "#8e4842"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.49,130.83a4.61,4.61,0,0,0-.62,1.19,12.88,12.88,0,0,0-.83,6.38,4.31,4.31,0,0,0,.3,1.3,23,23,0,0,1,0-4.51A23.53,23.53,0,0,1,206.49,130.83Z",
    style: {
      fill: "#8e4842"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.53,130.26a10.3,10.3,0,0,0-.72,3.39,10.6,10.6,0,0,0,.15,3.45c.09,0,0-1.54.13-3.43S202.61,130.28,202.53,130.26Z",
    style: {
      fill: "#8e4842"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.23,178.81l-.09-.67C155.16,178.29,155.21,178.61,155.23,178.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.14,178.14v0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.25,179l0-.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.37,220.68a134.16,134.16,0,0,0,14.38-8.43l-4.59-15.36-6.5,1c-.58-6.68-2.64-13.15-3.41-19l-7.87-26.06-17.17-1.56-20.87-1.53-13.29,1.92c-7.3,1-15.8,5.06-19.31,11.55-1.25,2.32-2.08,7.5-2.37,10.47-1.1,11.11,3,45,14.62,57.05L83.12,248.3c-8.39,26.15,77.87,15.15,77.12,5-1-4.8-5.67-25.3-5.67-25.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.14,178.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.12,205.52c.11.15-2.37,1.59-4.32,4.4s-2.5,5.61-2.68,5.56.12-3,2.2-5.89A10.61,10.61,0,0,1,111.12,205.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M89.35,230.87c1.71,3.63,5.39,6,9.28,7.06a32.68,32.68,0,0,0,12,.31c16-1.87,42.89-17.67,42.44-17.37C132.85,232.25,97.29,236.66,89.35,230.87Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M169.75,212.25s-.05.05-.18.14l-.57.36c-.5.31-1.24.77-2.2,1.34-1.93,1.14-4.76,2.75-8.31,4.61a158,158,0,0,1-29.05,11.75,66.64,66.64,0,0,1-8.79,1.7c-2.87.4-5.64.67-8.29.89s-5.16.38-7.52.48a48.45,48.45,0,0,1-6.58-.15,20.65,20.65,0,0,1-9.09-2.68,11.13,11.13,0,0,1-2-1.65l-.44-.52a.75.75,0,0,1-.13-.18,15.18,15.18,0,0,0,2.68,2.17,21,21,0,0,0,9,2.5,53.53,53.53,0,0,0,6.52.08c2.35-.12,4.86-.31,7.5-.53s5.41-.51,8.26-.91a69.79,69.79,0,0,0,8.72-1.7,166.89,166.89,0,0,0,29-11.57c3.57-1.82,6.42-3.38,8.37-4.47l2.26-1.25.59-.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.16,196.89a.79.79,0,0,1-.23.06l-.68.14-2.63.47-9.68,1.63-32,5.18-8.81,1.4-.19,0-.08-.18L100.77,181.3c-1.23-3-2.22-5.45-2.93-7.17l-.77-1.94a3.32,3.32,0,0,1-.23-.68,4.77,4.77,0,0,1,.32.64l.85,1.91c.73,1.71,1.78,4.12,3.07,7.12l10.28,24.24-.28-.15,8.81-1.41,32-5,9.71-1.46,2.64-.37.69-.09A1.1,1.1,0,0,1,165.16,196.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.22,165a23.22,23.22,0,0,0,1.17,3.19c.76,2,1.76,4.66,2.69,7.72s1.62,5.86,2.08,7.9a22.38,22.38,0,0,0,.8,3.3,14.7,14.7,0,0,0-.38-3.38,65,65,0,0,0-1.91-8A67.78,67.78,0,0,0,151.8,168,15.27,15.27,0,0,0,150.22,165Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,146.11a3.36,3.36,0,0,1-1.28,1.82,2.91,2.91,0,0,1-2.48.48,3.06,3.06,0,0,1-2.1-2.47,2.88,2.88,0,0,1,.4-1.89,6,6,0,0,1,1.49-1.59c1.19-.94,2.84-1.71,3.79-3.34a6.84,6.84,0,0,0,.64-5.53,7.83,7.83,0,0,0-1.4-2.66,12.07,12.07,0,0,0-2.26-2.08,15.15,15.15,0,0,1-2.25-1.92,3.92,3.92,0,0,1-1.09-2.47,4.82,4.82,0,0,1,.74-2.55,9.73,9.73,0,0,1,1.67-2,19.89,19.89,0,0,0,3.45-3.69,7.44,7.44,0,0,0,1.08-4.27,9.74,9.74,0,0,0-1-3.51,19.9,19.9,0,0,1-1-2.52,5.66,5.66,0,0,1-.13-2.27s0,0-.06.14a2.2,2.2,0,0,0-.09.44,4.3,4.3,0,0,0,.1,1.73,17.82,17.82,0,0,0,.89,2.59,9.59,9.59,0,0,1,.87,3.41,7.27,7.27,0,0,1-1.08,4,20.66,20.66,0,0,1-3.42,3.57,10.25,10.25,0,0,0-1.76,2.13,5.37,5.37,0,0,0-.82,2.81,4.43,4.43,0,0,0,1.21,2.78,16.83,16.83,0,0,0,2.32,2,11.25,11.25,0,0,1,2.18,2,7.67,7.67,0,0,1,1.32,2.49,6.46,6.46,0,0,1-.57,5.15c-.85,1.51-2.41,2.27-3.65,3.25a6.27,6.27,0,0,0-1.57,1.73,3.19,3.19,0,0,0-.42,2.13,3.38,3.38,0,0,0,2.37,2.69,3.15,3.15,0,0,0,2.67-.59,3.2,3.2,0,0,0,1.05-1.39A1.78,1.78,0,0,0,148,146.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.59,95.46a3.1,3.1,0,0,1,.65,2.23,14,14,0,0,1-.31,2.79,14.29,14.29,0,0,1-.78,2.7A3.13,3.13,0,0,1,95.69,105c-.68.28-1.58,0-2.3-1.06a5.07,5.07,0,0,1-.79-2,6.84,6.84,0,0,1,0-2.55,7,7,0,0,1,1-2.37,5.16,5.16,0,0,1,1.48-1.5A2,2,0,0,1,97.59,95.46Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.44,122.81c-1-2.72-.08-5.75,1.22-8.32s3-5,3.91-7.7c1-3,.9-6.22,2.09-9.11a11.4,11.4,0,0,1,6.87-6.41c1.85-.61,3.91-.77,5.52-1.89s2.51-3.12,3.76-4.7c2-2.57,4-4.78,7-6,3.45-1.44,8.5-2,12-.56a10,10,0,0,1,4.92,4.8,20.9,20.9,0,0,1,1.88,6.73c3.54.68,5.59,4.31,7.16,7.55a14.62,14.62,0,0,1,1.86,5.75c.07,2.26-1.87,10-3,12-5.65,10.22-14.06,12.37-24.28,18-3.94,2.18-6.38,7.2-10.89,7-5.25-.21-10.35-.41-13.4-4.69s-6.47-8.32-6.92-13.55",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.48,106.65c-.29-7.32-4.92-16.39-12.22-15.8l-22.87,5.21a4.29,4.29,0,0,0-3.93,4.25l1.13,54.88-.16,0s4.78,15.59,19.92,11.26c3-.86,4.45-4.08,5.13-7.42l.15,0c0-.39,0-.76.05-1.14a36.21,36.21,0,0,0,.28-7.53h0c.16-4.42.2-6.24.2-6.2s9.38-1.32,11.6-13.46C143.86,124.72,143.8,114.78,143.48,106.65Z",
    style: {
      fill: "#b2655f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.92,115.81a1.57,1.57,0,0,1-1.55,1.54,1.49,1.49,0,0,1-1.57-1.45,1.55,1.55,0,0,1,1.54-1.54A1.49,1.49,0,0,1,124.92,115.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,115.81a1.57,1.57,0,0,1-1.54,1.54,1.5,1.5,0,0,1-1.58-1.45,1.55,1.55,0,0,1,1.54-1.54A1.49,1.49,0,0,1,141,115.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.83,112c-.2.27-1.55-.79-3.38-.71s-3.11,1.2-3.33,1,.09-.59.65-1.11a4.26,4.26,0,0,1,2.64-1.08,4.12,4.12,0,0,1,2.71.89C141.71,111.41,141.93,111.87,141.83,112Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.88,112.23c-.24.24-1.55-.93-3.5-1s-3.44.84-3.64.58.16-.57.81-1a4.78,4.78,0,0,1,2.93-.77,4.59,4.59,0,0,1,2.77,1.15C124.82,111.66,125,112.13,124.88,112.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.48,124.3a10.92,10.92,0,0,1,2.74-.43c.43,0,.84-.11.91-.4a2.2,2.2,0,0,0-.25-1.28c-.38-1-.78-2.15-1.19-3.3-1.66-4.69-2.84-8.55-2.65-8.61s1.68,3.68,3.33,8.38l1.14,3.31a2.47,2.47,0,0,1,.18,1.69,1.08,1.08,0,0,1-.72.62,3.38,3.38,0,0,1-.73.08A11.36,11.36,0,0,1,130.48,124.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.16,144.21a30.94,30.94,0,0,1-16.2-4.73s3.89,8.72,16.11,7.87Z",
    style: {
      fill: "#8e4842"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.67,128.33a3,3,0,0,0-2.69-1.19,2.76,2.76,0,0,0-1.93,1,1.75,1.75,0,0,0-.18,2,2,2,0,0,0,2.19.61,6.35,6.35,0,0,0,2.17-1.23,1.8,1.8,0,0,0,.5-.49.58.58,0,0,0,0-.62",
    style: {
      fill: "#8e4842"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.5,125.34c.27,0,.24,1.82,1.77,3.15s3.47,1.18,3.48,1.43-.44.35-1.26.35a4.53,4.53,0,0,1-2.91-1.09,4,4,0,0,1-1.37-2.64C125.16,125.78,125.38,125.33,125.5,125.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.3,106.53c-.18.46-1.85.2-3.83.39s-3.59.69-3.84.28c-.11-.2.18-.63.83-1a6.68,6.68,0,0,1,5.84-.51C125,106,125.37,106.32,125.3,106.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.69,106.89c-.35.37-1.66-.06-3.25-.11s-2.95.18-3.25-.22c-.13-.2.09-.58.69-.92a5.26,5.26,0,0,1,5.24.26C140.67,106.31,140.84,106.7,140.69,106.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.33,97.3c1.29-1.6,3.38-2.28,5.37-2.83A111.72,111.72,0,0,1,135,90.53c.91,1.91-.34,4.25-2.12,5.4s-3.95,1.44-6,2-4.18,1.47-5.18,3.33-.59,4.49-1.56,6.52c-1.67,3.49-6.84,4.15-8.49,7.64-1.25,2.65-.43,2-.33,5,.12,3.31-1.91,3.81-4.53,5.84-2.07,1.6-6,3.44-8.65,3.23.45-10.45,3.15-15.47,3.6-25.92C101.81,101.34,102,99,103.33,97.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.93,80.69l.22-.16a7.34,7.34,0,0,1,.66-.4,10.32,10.32,0,0,1,2.65-1,11.64,11.64,0,0,1,4.2-.19,10.77,10.77,0,0,1,8.21,5.68,11.77,11.77,0,0,1,1.3,4,10.12,10.12,0,0,1,0,2.83,6.3,6.3,0,0,1-.14.76,1.23,1.23,0,0,1-.07.26,13.65,13.65,0,0,0,0-3.82,11.77,11.77,0,0,0-1.33-3.91,10.64,10.64,0,0,0-8-5.55,11.84,11.84,0,0,0-4.13.13A13.62,13.62,0,0,0,117.93,80.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.23,90.56a1.18,1.18,0,0,1,.35,0,4.59,4.59,0,0,0,1-.1,6,6,0,0,0,1.49-.53,12.47,12.47,0,0,0,1.76-1.13c.63-.47,1.29-1,2-1.58a13,13,0,0,1,2.49-1.6,13.67,13.67,0,0,1,6.61-1.29,13.34,13.34,0,0,1,6.43,2,13.54,13.54,0,0,1,4,3.82A13.23,13.23,0,0,1,134,93.47a9.86,9.86,0,0,1,.28,1,1.45,1.45,0,0,1,.06.34s-.13-.47-.44-1.28a14,14,0,0,0-5.68-7,13.15,13.15,0,0,0-6.31-2,13.66,13.66,0,0,0-6.49,1.24A13.16,13.16,0,0,0,113,87.39c-.73.55-1.4,1.09-2,1.56a12,12,0,0,1-1.82,1.11,6,6,0,0,1-1.53.5,4.08,4.08,0,0,1-1,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,103.58a22.44,22.44,0,0,0,.64,3,13.5,13.5,0,0,0,10.41,9.3,23.08,23.08,0,0,0,3,.3s-.07,0-.21,0-.34,0-.61,0a11.93,11.93,0,0,1-2.24-.17,13.27,13.27,0,0,1-10.57-9.44A11.43,11.43,0,0,1,96,104.4a5.52,5.52,0,0,1,0-.61A.67.67,0,0,1,96,103.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.53,121.66a4.79,4.79,0,0,1-.83-.13c-.53-.11-1.28-.29-2.2-.57A16.64,16.64,0,0,1,98,117.31a10.89,10.89,0,0,1-3.38-6.61,7.92,7.92,0,0,1,.08-2.28,6,6,0,0,1,.15-.61.8.8,0,0,1,.07-.2,10.15,10.15,0,0,0,3.26,9.51,17.51,17.51,0,0,0,6.41,3.66c.91.3,1.66.51,2.17.65A5.08,5.08,0,0,1,107.53,121.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.74,88.61a14.72,14.72,0,0,0-4,.07,15.77,15.77,0,0,0-3.74,1.4,3.87,3.87,0,0,1,1-.68,8.89,8.89,0,0,1,2.71-1,9.25,9.25,0,0,1,2.88-.09A3.56,3.56,0,0,1,145.74,88.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.87,82.3a4.15,4.15,0,0,1,.09,1.28,11.28,11.28,0,0,1-.53,3,11.06,11.06,0,0,1-1.36,2.78,4,4,0,0,1-.82,1,17.89,17.89,0,0,0,1.92-3.85A18.32,18.32,0,0,0,140.87,82.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.64,116.83c-.19-.09-7.62-2.6-7.69,5.08s7.65,6.17,7.67,6S107.64,116.83,107.64,116.83Z",
    style: {
      fill: "#b2655f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.3,124.93s-.14.09-.36.19a1.3,1.3,0,0,1-1,0c-.81-.3-1.48-1.6-1.51-3a4.54,4.54,0,0,1,.39-1.92,1.54,1.54,0,0,1,1-1,.68.68,0,0,1,.79.37c.1.22.05.37.09.38s.16-.12.11-.44a.88.88,0,0,0-.3-.49,1,1,0,0,0-.74-.2,1.91,1.91,0,0,0-1.41,1.18,4.47,4.47,0,0,0-.48,2.14c0,1.54.81,3,1.92,3.33a1.4,1.4,0,0,0,1.22-.19C105.28,125.11,105.33,124.94,105.3,124.93Z",
    style: {
      fill: "#8e4842"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.18,126.19a3.56,3.56,0,0,1-.35.22c-.24.14-.6.32-1,.6a7.27,7.27,0,0,0-2.71,3.3,7.23,7.23,0,0,0,.33,6.19,7.17,7.17,0,0,0,6.4,3.78,7.17,7.17,0,0,0,2-.32,6.48,6.48,0,0,0,1.81-.83,7.25,7.25,0,0,0-.08-12.2,12.12,12.12,0,0,0-1.42-.74,5.46,5.46,0,0,1,1.48.65,7.3,7.3,0,0,1,2.9,3.26,7.5,7.5,0,0,1,.64,3,7.21,7.21,0,0,1-.8,3.4,7.29,7.29,0,0,1-2.58,2.87,6.94,6.94,0,0,1-1.87.87,7.37,7.37,0,0,1-2.1.33,7.38,7.38,0,0,1-6.62-3.93,7.34,7.34,0,0,1,2.54-9.7c.45-.27.82-.43,1.06-.56A1.82,1.82,0,0,1,101.18,126.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.35,102.76a1.75,1.75,0,0,1,0,.37,10,10,0,0,1-.11,1.08A15.39,15.39,0,0,1,94.11,108c-.65,1.55-1.62,3.29-2.63,5.24A31.17,31.17,0,0,0,90,116.37a14.73,14.73,0,0,0-1,3.55,13.25,13.25,0,0,0,1,7,14.08,14.08,0,0,0,1.59,2.66c.58.79,1.14,1.51,1.66,2.16,1,1.3,1.92,2.32,2.54,3l.7.81a1.62,1.62,0,0,1,.24.29,2.3,2.3,0,0,1-.28-.26l-.74-.77c-.64-.68-1.54-1.69-2.61-3-.53-.65-1.1-1.36-1.69-2.14a13.92,13.92,0,0,1-1.63-2.7,13.12,13.12,0,0,1-1.08-7.08,14.53,14.53,0,0,1,1-3.61,30.73,30.73,0,0,1,1.46-3.15c1-2,2-3.68,2.68-5.21a16.3,16.3,0,0,0,1.21-3.73,9.68,9.68,0,0,0,.15-1.06A1.93,1.93,0,0,1,95.35,102.76Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.43,400.68,369,383.37l-31.24-53.49a30.13,30.13,0,0,0-12-8.33l-11-4.18-27.34-5L268,320a11.61,11.61,0,0,0-7.27,12.16l5.08,42.75,3,55.66,70.54-12.23-7.09-20.59.23-32.1Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.86,396.38c.17,0,.21-11.12.1-24.83s-.34-24.83-.5-24.83-.21,11.12-.1,24.84S332.7,396.38,332.86,396.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.28,404.54l-42.63-17.16a9.74,9.74,0,0,1-6.07-8.29l-3.12-40.87S278.83,320.84,268,320l-6.17,2.43c-8,4.24-10,15.86-8.88,24.83,1.55,12.75,2.19,30.79,3.92,41.86,1.41,9.05,6.85,16.21,15.46,19.34l52.5,11.37Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.07,344.46a5.21,5.21,0,0,1,.14.93q.09,1,.27,2.7c.22,2.39.52,5.76.9,9.91s.79,9.18,1.26,14.7c.12,1.38.24,2.8.36,4.25a32.42,32.42,0,0,0,.55,4.37,7.22,7.22,0,0,0,2.11,3.83,14.38,14.38,0,0,0,3.94,2.45c11.75,5.09,22.58,9.29,30.45,12.23l9.33,3.44,2.54.94a4.49,4.49,0,0,1,.87.36,5.67,5.67,0,0,1-.91-.26l-2.57-.83c-2.23-.74-5.45-1.85-9.4-3.27-7.91-2.85-18.76-7-30.55-12.09a14.83,14.83,0,0,1-4.09-2.56,7.84,7.84,0,0,1-2.27-4.11,31.93,31.93,0,0,1-.54-4.45c-.12-1.45-.23-2.87-.34-4.26-.43-5.52-.82-10.51-1.14-14.71s-.55-7.53-.72-9.93c-.07-1.13-.13-2-.17-2.7A6.05,6.05,0,0,1,279.07,344.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.65,366.67a1.9,1.9,0,0,1,.08.55l.15,1.58c.12,1.46.29,3.42.5,5.8s.53,5.35,1,8.57a80,80,0,0,0,1.92,10.35,15.39,15.39,0,0,0,2.08,4.94,28.46,28.46,0,0,0,3.18,3.91,27.08,27.08,0,0,0,6.83,5.12,25.48,25.48,0,0,0,7.48,2.45,2.3,2.3,0,0,1-.55,0,12.37,12.37,0,0,1-1.58-.21,20.92,20.92,0,0,1-5.54-1.87,26.87,26.87,0,0,1-7-5.11,28.23,28.23,0,0,1-3.27-4,16,16,0,0,1-2.17-5.09,79.17,79.17,0,0,1-1.9-10.44c-.39-3.23-.65-6.15-.83-8.61s-.28-4.44-.33-5.82c0-.63,0-1.15,0-1.58A2,2,0,0,1,254.65,366.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.88,395.27a6.13,6.13,0,0,1,.77-2.27,14.65,14.65,0,0,1,8.65-7.39,6.37,6.37,0,0,1,2.37-.41c0,.1-.88.27-2.24.79a17.15,17.15,0,0,0-4.83,2.88,16.86,16.86,0,0,0-3.59,4.32C273.28,394.45,273,395.3,272.88,395.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M318,399.67c-4.56-2.57-9-4.55-13.78-6.72s-9.44-4.94-12.56-9.15c-5.88-7.93-5.21-19.37-11.23-27.19q.59,7.89,1.18,15.78c.36,4.82-.38,9.59,2.73,12.87,2.61,2.76,7.71,4.87,11.33,6.07,7.25,2.39,15.07,5.95,22.33,8.34"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "332.46 349.73 336.15 372.47 332.66 366.03 332.46 349.73"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M279.2,339.36c-.09,0-.22-1.45-1-3.63a18.25,18.25,0,0,0-12.92-11.61c-2.26-.56-3.72-.54-3.72-.63a4.12,4.12,0,0,1,1,0,16.28,16.28,0,0,1,2.77.35,17.68,17.68,0,0,1,13.15,11.82,15.49,15.49,0,0,1,.65,2.72A3.58,3.58,0,0,1,279.2,339.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330,327.76a74.92,74.92,0,0,1,1.5,7.95,74.41,74.41,0,0,1,1.05,8,75.45,75.45,0,0,1-1.5-8A68.79,68.79,0,0,1,330,327.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.49,455.92s32.77,9.07,34.08,9.53c2,.7,1.64,7.93-1.43,7.81-1.45-.05-25.16.89-28.16.7s-12-3.75-12-3.75Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.14,468.42a32.26,32.26,0,0,1,1.45-3.52,30.44,30.44,0,0,1,2.31-3,7.28,7.28,0,0,0-3.76,6.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.73,466.87c.16,0,.49-1.52,1.36-3.23s1.9-2.91,1.78-3a8.18,8.18,0,0,0-3.14,6.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.52,466a11.55,11.55,0,0,1,2.55-6.52,6.16,6.16,0,0,0-2.55,6.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.1,461.78a5.72,5.72,0,0,0,.35-2.44,11.47,11.47,0,0,0-.33-2.67,11.13,11.13,0,0,0-.49-1.52,1.72,1.72,0,0,0-.52-.8.88.88,0,0,0-1.13.06,1.43,1.43,0,0,0-.43.92,6.41,6.41,0,0,0,0,.87,6.87,6.87,0,0,0,.2,1.6,9.64,9.64,0,0,0,1,2.51,6.73,6.73,0,0,0,1.47,2c.07,0-.48-.82-1.13-2.15a10.81,10.81,0,0,1-.86-2.44,7.26,7.26,0,0,1-.16-1.5c0-.5,0-1.13.3-1.37a.33.33,0,0,1,.44,0,1.55,1.55,0,0,1,.36.57,11.26,11.26,0,0,1,.49,1.45,13,13,0,0,1,.44,2.56C385.16,460.84,385,461.77,385.1,461.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.06,461.45a4.55,4.55,0,0,0-2.11-.34,9.87,9.87,0,0,0-2.33.28,5.2,5.2,0,0,0-1.33.5,1.37,1.37,0,0,0-.74,1.49,1.63,1.63,0,0,0,1.18,1.17,2.92,2.92,0,0,0,1.47,0,7.17,7.17,0,0,0,3.65-2.55,14.41,14.41,0,0,0-1.75,1.18,5.61,5.61,0,0,1-2,.87,2.6,2.6,0,0,1-1.21,0,1.11,1.11,0,0,1-.8-.78.86.86,0,0,1,.49-.92,5.26,5.26,0,0,1,1.18-.46,10.67,10.67,0,0,1,2.21-.38C384.24,461.41,385.05,461.54,385.06,461.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.18,468.77a17.3,17.3,0,0,1,.64-2.95,17.11,17.11,0,0,1,1.61-2.57,3.82,3.82,0,0,0-2.12,2.36A3.76,3.76,0,0,0,396.18,468.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.31,470.28a6.5,6.5,0,0,0,1.27.6,28.41,28.41,0,0,0,3.65,1.13,52,52,0,0,0,12.51,1.19c4.91-.06,9.33-.28,12.54-.41l3.8-.2a6.69,6.69,0,0,0,1.39-.15,6.52,6.52,0,0,0-1.4-.06l-3.8,0-12.54.25a58.28,58.28,0,0,1-12.42-1C375.18,471,373.35,470.18,373.31,470.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.35,471c0,.08.94-.45,2.45-1.11a11.44,11.44,0,0,1,6.2-1,9.84,9.84,0,0,1,5.36,3.19,20.11,20.11,0,0,0,1.89,1.93,9.75,9.75,0,0,0-1.61-2.2,13.13,13.13,0,0,0-2.17-2,7.85,7.85,0,0,0-3.38-1.43,10.81,10.81,0,0,0-6.45,1.22A8.56,8.56,0,0,0,372.35,471Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.72,448.31s-31,20.3-32.12,21.14c-1.67,1.27.25,7.27,3.14,6.23,1.37-.49,27.38-7.73,30.18-8.82s10.33-7.22,10.33-7.22Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.51,464.37a5.8,5.8,0,0,0-2.07-3.32,5.87,5.87,0,0,0-3.5-1.76,27.83,27.83,0,0,1,3.13,2.17A31.51,31.51,0,0,1,329.51,464.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.29,461.86a6,6,0,0,0-1.89-3.05,6.14,6.14,0,0,0-3-1.95c-.07.14,1.28.95,2.62,2.33S332.15,461.93,332.29,461.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.09,460.07a6.18,6.18,0,0,0-4.42-5.45,22,22,0,0,1,2.64,2.38A22.57,22.57,0,0,1,335.09,460.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.25,456.21c.08,0-.35-.88-.7-2.32a12.77,12.77,0,0,1-.37-2.57,11.34,11.34,0,0,1,0-1.53,1.35,1.35,0,0,1,.16-.65.33.33,0,0,1,.43-.1c.35.14.54.75.7,1.22a7.28,7.28,0,0,1,.31,1.47,11.35,11.35,0,0,1-.08,2.59c-.22,1.47-.51,2.36-.42,2.39a6.73,6.73,0,0,0,.8-2.33,9.69,9.69,0,0,0,.2-2.69,7.75,7.75,0,0,0-.29-1.59,5.82,5.82,0,0,0-.31-.81,1.44,1.44,0,0,0-.7-.75.85.85,0,0,0-1.08.29,1.8,1.8,0,0,0-.26.92,10.68,10.68,0,0,0,0,1.6,11.72,11.72,0,0,0,.49,2.65A5.79,5.79,0,0,0,333.25,456.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.18,455.88c0,.08.77-.29,2-.59a11.2,11.2,0,0,1,2.22-.31,5.36,5.36,0,0,1,1.27.08.87.87,0,0,1,.75.73,1.12,1.12,0,0,1-.53,1,2.58,2.58,0,0,1-1.15.39,6,6,0,0,1-2.18-.22,14.69,14.69,0,0,0-2-.6,7,7,0,0,0,4.25,1.32,3.05,3.05,0,0,0,1.4-.44,1.64,1.64,0,0,0,.77-1.48,1.38,1.38,0,0,0-1.16-1.2,5.34,5.34,0,0,0-1.42-.06,10,10,0,0,0-2.31.43A4.71,4.71,0,0,0,333.18,455.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.69,474.55c0,.05.52-.31.76-1.2a4.58,4.58,0,0,0-.58-3.37,12.88,12.88,0,0,0-1-1.54,5.79,5.79,0,0,0-1.05-1.13,1.88,1.88,0,0,0-1-.42c-.26,0-.39.05-.39.09a2.86,2.86,0,0,1,1.13.62,7.18,7.18,0,0,1,.89,1.13,16.6,16.6,0,0,1,1,1.52,4.79,4.79,0,0,1,.68,3A11.82,11.82,0,0,1,313.69,474.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.82,466.23a4.68,4.68,0,0,0-3.82-4.57,17.34,17.34,0,0,1,2.31,1.95A18,18,0,0,1,324.82,466.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.06,460.73a11.22,11.22,0,0,0-1.36.94,39.71,39.71,0,0,1-3.82,2.34,51.54,51.54,0,0,1-6.08,2.7c-2.34.88-5,1.7-7.76,2.51-5.58,1.61-10.63,3.07-14.27,4.17l-4.31,1.32a9.87,9.87,0,0,0-1.56.56,9.08,9.08,0,0,0,1.62-.35l4.36-1.16c3.67-1,8.73-2.41,14.31-4,2.79-.81,5.44-1.66,7.79-2.57a45,45,0,0,0,6.08-2.83,30.7,30.7,0,0,0,3.77-2.51A8.81,8.81,0,0,0,347.06,460.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.21,461.15a8.77,8.77,0,0,0-2.63-.7,10.79,10.79,0,0,0-6.51.8,7.66,7.66,0,0,0-2.79,2.39,12.89,12.89,0,0,0-1.45,2.6,10.11,10.11,0,0,0-.87,2.57,19.68,19.68,0,0,0,1.22-2.41,9.81,9.81,0,0,1,4.13-4.66,11.49,11.49,0,0,1,6.22-.91C347.18,461,348.19,461.23,348.21,461.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.17,397.55s9.3,3.32,9.34,13.75c.07,20-40.37,42-40.37,42l-53.81-35.66L315,416.28S387.6,389,403.17,397.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.59,435.65a10.26,10.26,0,0,0,1.4-.95c.88-.64,2.14-1.59,3.68-2.78,3.08-2.38,7.28-5.76,11.78-9.63s8.48-7.5,11.3-10.19c1.42-1.34,2.54-2.44,3.31-3.22a9.69,9.69,0,0,0,1.15-1.24,9.11,9.11,0,0,0-1.3,1.09l-3.42,3.09c-2.88,2.61-6.89,6.19-11.39,10.06s-8.65,7.28-11.67,9.74l-3.57,2.91A10,10,0,0,0,345.59,435.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388,405a10.55,10.55,0,0,0-5.19.47,10.69,10.69,0,0,0-4.61,2.42c.09.14,2.05-1.11,4.77-1.9S388,405.18,388,405Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.34,401.87a8.17,8.17,0,0,0-4.86,6c.15.06.74-1.62,2.1-3.28S383.43,402,383.34,401.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.13,465.12c0-.06-.65-.19-1.39.42a5.07,5.07,0,0,0-1.56,3.12,6.23,6.23,0,0,0,.49,3.45c.38.82.8,1.2.85,1.16A10,10,0,0,0,404,472a7,7,0,0,1-.3-3.22,5.32,5.32,0,0,1,1.27-2.91C405.57,465.23,406.14,465.21,406.13,465.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.32,369.18,384,410.42a6,6,0,0,1-5.65,3.87l-84.27-1.11v-6.4l31.27,1.14,13.28-41.17a3.34,3.34,0,0,1,3.2-2.32l54.36.15A3.37,3.37,0,0,1,399.32,369.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.32,369.18l0-.13a2.19,2.19,0,0,0,.11-.39,3.25,3.25,0,0,0,0-1.55,3.41,3.41,0,0,0-1.48-2,3.33,3.33,0,0,0-1.53-.48c-.58,0-1.21,0-1.88,0l-22.67,0-15.89,0-8.93,0h-4.69a3.69,3.69,0,0,0-2.24.49,3.32,3.32,0,0,0-1.4,1.84c-4,12.44-8.47,26.29-13.23,41.09l0,.1h-.1l-31.27-1.14.14-.13v6.4l-.14-.13,53,.71,23,.31,5.31.07,2.58,0a5.94,5.94,0,0,0,2.45-.36,5.82,5.82,0,0,0,3.38-3.25q.84-2.25,1.64-4.39l10.11-27.11,2.75-7.34c.64-1.68,1-2.55,1-2.55s-.31.88-.93,2.57l-2.7,7.36-10,27.13q-.8,2.16-1.64,4.41a6,6,0,0,1-3.49,3.37,6.33,6.33,0,0,1-2.52.37l-2.58,0-5.31-.07-23-.29-53-.68H294v-6.68h.14l31.27,1.15-.13.09c4.77-14.8,9.24-28.64,13.26-41.08a3.51,3.51,0,0,1,1.5-2,3.87,3.87,0,0,1,2.36-.52h4.69l8.93,0,15.89.06,22.67.1c.67,0,1.29,0,1.88,0a3.39,3.39,0,0,1,1.56.5,3.42,3.42,0,0,1,1.49,2,3.15,3.15,0,0,1,0,1.57A4.54,4.54,0,0,1,399.32,369.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,384.77a3.8,3.8,0,0,1,4.1.44,3.31,3.31,0,0,1,.8,3.63,3.59,3.59,0,0,1-3.08,2.15,3.25,3.25,0,0,1-3.25-2.15c-.39-1.35,0-3.36,1.43-4.07",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.22,455.54s-76-48.64-79.3-50.55c-2.85-1.63-10.48-6.32-18-4.25s-14.26,8.82-17.64,18.68c-1.92,5.63-2.83,15.24-3.26,22.45a33.34,33.34,0,0,0,7.79,23.75,21.35,21.35,0,0,0,9.48,6.73c.79.24,1.62.45,2.46.64A35.77,35.77,0,0,0,320,457.36l1.78-2.7s49.73,18.27,50.51,18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.84,407.68s-.07,0-.19-.11l-.53-.36c-.47-.32-1.15-.8-2.05-1.38a40.23,40.23,0,0,0-8.07-4.1,21.83,21.83,0,0,0-6.07-1.28,17.62,17.62,0,0,0-7,1.14,22.43,22.43,0,0,0-6.71,4.08,31.62,31.62,0,0,0-3,2.92,22,22,0,0,0-2.46,3.51,36,36,0,0,0-3.28,7.83c-.71,2.64-1.29,5.26-1.83,7.73A70.34,70.34,0,0,0,262.92,441a48,48,0,0,0,.69,9c.17,1.06.36,1.87.47,2.43q.07.38.12.63a.6.6,0,0,1,0,.22.8.8,0,0,1-.07-.21c-.05-.17-.1-.37-.17-.62-.14-.55-.36-1.36-.55-2.42a45.26,45.26,0,0,1-.84-9.07,69.33,69.33,0,0,1,1.66-13.4c.54-2.49,1.1-5.09,1.82-7.78a35.34,35.34,0,0,1,3.31-7.92,21.13,21.13,0,0,1,2.52-3.58,29.23,29.23,0,0,1,3-3,22.79,22.79,0,0,1,6.85-4.13,17.72,17.72,0,0,1,7.16-1.12,21.86,21.86,0,0,1,6.16,1.35,38.82,38.82,0,0,1,8.05,4.25c.89.61,1.56,1.11,2,1.45l.51.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.16,441.81l.41.19,1.25.49,4.82,1.86,17.91,6.75c7.61,2.84,16.72,6.21,26.95,9.93s21.56,7.8,33.66,11.9l.22.07.11-.2c1.9-3.63,3.91-7.46,5.94-11.35l3-5.78.12-.22-.21-.14-58-36.81-17.42-11-4.73-2.95L300,403.8c-.28-.17-.43-.24-.43-.24l.4.29c.29.19.7.45,1.21.8l4.68,3,17.33,11.13,57.9,37-.1-.36-3,5.79L372,472.54l.33-.13c-12.1-4.08-23.44-8.15-33.67-11.83l-27-9.82-18-6.6-4.86-1.76-1.26-.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.09,280.43a39.06,39.06,0,0,1-3.38-8.07,13.16,13.16,0,0,1,.45-8.59c.71-1.56,1.82-2.92,2.38-4.54.76-2.22.45-4.85,1.83-6.76,2.15-3,6.76-2.28,10.08-3.84,2.6-1.22,4.41-3.84,7.13-4.71,2.39-.77,5,0,7.28,1s4.54,2.24,7,2.56a50,50,0,0,0,5.34,0,7,7,0,0,1,4.93,1.7c1.26,1.26,1.52,3.6.16,4.76,3.12-.53,6.06,2.58,6,5.75s-2.43,5.94-5.3,7.26a19,19,0,0,1-9.32,1.16c-8.93-.7-17.9-4.09-24-10.67",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293,269.26l-6.08,44.21a13.27,13.27,0,0,0,12,15h0a13.29,13.29,0,0,0,14.32-11.44c.45-3.33.84-6.1.91-6.44,0,0,11.4.49,13.74-10.54,1.14-5.33,2.58-16.49,3.76-26.61a21,21,0,0,0-16.75-23l-1.07-.22C302.2,248.61,294.32,257.58,293,269.26Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.2,310.47a26.19,26.19,0,0,1-13.6-7s1.82,8.64,13,9.84Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.7,282.88a1.63,1.63,0,0,1-1.85,1.29,1.54,1.54,0,0,1-1.34-1.75,1.61,1.61,0,0,1,1.84-1.29A1.55,1.55,0,0,1,326.7,282.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.19,278.43c-.23.17-1.25-1-2.95-1.29s-3.12.26-3.26,0,.2-.44.82-.73a4.38,4.38,0,0,1,2.66-.27,4.18,4.18,0,0,1,2.3,1.28C328.21,278,328.31,278.36,328.19,278.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.85,280.14a1.61,1.61,0,0,1-1.84,1.29,1.54,1.54,0,0,1-1.34-1.75,1.6,1.6,0,0,1,1.84-1.29A1.54,1.54,0,0,1,310.85,280.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.43,275.41c-.24.17-1.26-1-3-1.29s-3.11.26-3.25,0,.2-.44.82-.73a4.36,4.36,0,0,1,2.66-.27,4.18,4.18,0,0,1,2.3,1.28C311.44,274.93,311.54,275.34,311.43,275.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.08,289.24a11.41,11.41,0,0,1,2.86.05c.44,0,.87,0,1-.24a2.19,2.19,0,0,0,0-1.34c-.2-1.13-.41-2.32-.62-3.56-.85-5.06-1.36-9.19-1.16-9.22s1.05,4,1.89,9.1l.57,3.57a2.55,2.55,0,0,1-.12,1.75,1.1,1.1,0,0,1-.84.49,2.92,2.92,0,0,1-.75,0A11.57,11.57,0,0,1,315.08,289.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.84,289.42c.28,0-.08,1.88,1.24,3.51s3.32,1.81,3.28,2.07-.51.27-1.34.13a4.76,4.76,0,0,1-2.77-1.63,4.09,4.09,0,0,1-.91-2.92C309.42,289.8,309.72,289.38,309.84,289.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.2,268.84c-.26.43-1.91-.13-3.95-.29s-3.77.06-3.95-.4c-.08-.22.29-.6,1-.92a6.51,6.51,0,0,1,3.07-.43,6.65,6.65,0,0,1,3,1C313,268.2,313.32,268.63,313.2,268.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.55,273.39c-.37.32-1.46-.31-2.87-.61s-2.65-.26-2.84-.72c-.08-.22.18-.57.77-.83a4.28,4.28,0,0,1,4.61,1.07C328.64,272.8,328.72,273.23,328.55,273.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.28,277.63c-.17-.12-7.15-3.77-8.42,3.84s6.63,7.31,6.68,7.09S292.28,277.63,292.28,277.63Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.7,285.3s-.15.07-.39.13a1.37,1.37,0,0,1-1-.14c-.76-.43-1.22-1.82-1-3.2a4.42,4.42,0,0,1,.69-1.83,1.53,1.53,0,0,1,1.16-.85.69.69,0,0,1,.73.49c.06.23,0,.37,0,.39s.18-.1.17-.42a.8.8,0,0,0-.22-.53,1,1,0,0,0-.7-.32,1.92,1.92,0,0,0-1.58,1,4.63,4.63,0,0,0-.81,2c-.21,1.54.34,3.1,1.38,3.6a1.45,1.45,0,0,0,1.25,0C288.66,285.48,288.72,285.31,288.7,285.3Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.84,263.21c-1.3,2.81-8,3.89-12.93,2.41-4.54-1.37-6.18-4.25-9.07-6.76C310,257.27,310,257.27,307,257c-2.4-.25-4.34,2.15-6.16,3.74,1,6.05-1.67,12-4.29,17.57a3,3,0,0,1-1.23,1.57c-1,.51-2.26-.29-2.88-1.27a9.52,9.52,0,0,1-1.07-5.33A31.7,31.7,0,0,1,293.93,261a21.6,21.6,0,0,1,7.95-9.52A20.48,20.48,0,0,1,317,249a25.18,25.18,0,0,1,13.26,8,14.7,14.7,0,0,1,3.57,6.28",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.37,281.6c.06,0,0-.66.34-1.77a7.38,7.38,0,0,1,2.7-3.91,7.15,7.15,0,0,1,6.73-1,7,7,0,0,1,3.27,2.47,7,7,0,0,1,0,8.35,7,7,0,0,1-3.27,2.47,7.13,7.13,0,0,1-6.73-1,7.38,7.38,0,0,1-2.7-3.91c-.3-1.11-.28-1.77-.34-1.76a1.24,1.24,0,0,0,0,.47,6.06,6.06,0,0,0,.15,1.35,7.33,7.33,0,0,0,2.66,4.2,7.57,7.57,0,0,0,10.76-1.5,7.58,7.58,0,0,0,0-9.05,7.5,7.5,0,0,0-3.57-2.65,7.58,7.58,0,0,0-7.19,1.15,7.36,7.36,0,0,0-2.66,4.2,6.06,6.06,0,0,0-.15,1.35A1.32,1.32,0,0,0,318.37,281.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.33,278.45c.06,0,0-.66.34-1.77a7.35,7.35,0,0,1,2.69-3.91,7.17,7.17,0,0,1,6.74-1,7,7,0,0,1,3.27,2.47,7,7,0,0,1,0,8.35,7,7,0,0,1-3.27,2.47,7.15,7.15,0,0,1-6.74-1,7.35,7.35,0,0,1-2.69-3.91c-.3-1.11-.28-1.77-.34-1.76s0,.16,0,.47a5.51,5.51,0,0,0,.15,1.35,7.33,7.33,0,0,0,2.66,4.2,7.59,7.59,0,0,0,10.76-1.5,7.62,7.62,0,0,0,0-9.05,7.59,7.59,0,0,0-10.76-1.5,7.36,7.36,0,0,0-2.66,4.2,5.51,5.51,0,0,0-.15,1.35C300.29,278.28,300.3,278.45,300.33,278.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.19,278.7c.08.16,1-.3,2.17.05s1.68,1.24,1.83,1.16,0-.33-.22-.71a2.64,2.64,0,0,0-1.43-1,2.68,2.68,0,0,0-1.78.07C315.34,278.41,315.15,278.63,315.19,278.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.1,276.5c0,.17,2.43.27,5.42.23s5.41-.22,5.41-.39-2.43-.27-5.42-.23S290.1,276.33,290.1,276.5Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebDevices);
export default __webpack_public_path__ + "static/media/Web-devices.08087b9ecfecfc0f186065d1b09212dc.svg";
export { ForwardRef as ReactComponent };